export default {
    structuredData: {
        shippingCountry: 'SK',
    },
    xProducts: '-|{n} produkt|{n} produkty|{n} produktov',
    header: {
        locale: 'sk',
        currency: 'EUR',
        currencySymbol: '€',
        pieces: 'ks',
        closed: 'zatvorené',
        credits: 'kreditov | kredit | kredity | kreditov',
        showText: 'Zobraziť viac',
        hideText: 'Skryť',
        detail: 'Detail',
        close: 'Zavrieť',
        products: 'Produkty',
        download: 'Stiahnuť',
        loading: 'Načítanie',
        category: {
            title: 'Kategória',
            bestSellers: 'Najpredávanejšie produkty',
        },
        brands: 'Značky',
        addToCart: 'Do košíka',
        gift: 'Darček',
        todayAction: 'Dnešná akčná cena',
        of: 'z',
        from: 'od',
        url: {
            cartStep1: '/kosik',
            contact: '/kontakt',
            search: '/vyhladavanie',
            category: {
                sale: '/vypredaj',
                saleAndDiscount: '/akcie-a-zlavy',
                onePlusOne: '/akcie-a-zlavy?vt[0]=2',
                twoPlusOne: '/akcie-a-zlavy?vt[0]=3',
            },
            static: {
                pilulkaClub: '/pilulka-klub',
            },
            user: {
                login: '/prihlasit-sa',
                logout: '/backend/logout',
                profile: '/konto',
                profileSettings: '/informacie-o-pouzivatelovi',
                changePassword: '/zmena-hesla',
                orders: '/objednavky',
                feedback: '/hodnotenie',
                myFavorite: '/my-favorite',
                forgottenPassword: '/zabudnute-heslo',
                registration: '/registracia',
                deleteCreditCard: '/backend/user-delete-credit-card',
            },
            complaint: {
                createNew: '/complaint-step1?withdrawal=0',
                homepage: '/complaints',
            },
            counselling: '/poradna',
            pharmacies: '/pilulka-lekarny',
            orderRepeat: '/backend/order/repeat',
            cancelOrderByCustomer: '/backend/order/cancel_by_customer',
            prolongOrderByCustomer: '/backend/order/prolong_by_customer',
        },
        siteHeader: {
            logoTitle: 'Pilulka.sk - vaša online lekáreň s viac ako 1247 odbernými miestami po SR',
            basket: 'Košík',
            category: 'Kategória',
            chat: 'Chat',
            search: {
                title: 'Vyhľadať',
                placeholder: 'Hľadajte na Pilulka.sk',
                notfound: 'Skontrolujte prosím vyhľadávané slovo.',
                lastVisitsProducts: 'Naposledy navštívené',
                label: 'Hľadať',
                showXProducts: 'Zobraziť 0 produktov | Zobraziť 1 produkt | Zobraziť {n} produkty | Zobraziť {n} produktov',
                staticContents: 'Články',
                pharmacies: 'Lekárne',
                startSearch: 'Zadajte vyhľadávané slovo',
            },
            login: {
                incorrectLogin: 'Zadali ste zlý e-mail alebo heslo',
                email: 'Váš e-mail',
                password: 'Vaše heslo',
                showPassword: 'Zobraziť heslo',
                sendForgottenPassword: 'Zaslať zabudnuté heslo',
                title: 'Moja Pilulka',
                label: 'Prihlásiť',
                loginAction: 'Prihlásiť sa',
                loginWithFacebook: 'Prihlásiť cez Facebook',
                loginWithGoogle: 'Prihlásiť cez Google',
                register: 'Registrovať sa',
                favoriteAndRecentlyPurchasedProducts: 'Obľúbené a zakúpené produkty',
                myRatings: 'Moje hodnotenie',
                favoriteProducts: 'Obľúbené produkty',
                reviewClub: 'Recenzný Klub',
                userInfo: 'Osobné údaje',
                credits: '%{credits} kreditov',
                orders: 'Objednávky',
                ratings: 'Hodnotenie produktu',
                myProfile: 'Môj profil',
                logout: 'Odhlásiť sa',
                google: 'Prihlásiť cez Google',
            },
            cartBox: {
                basket: 'Košík',
                cart: 'Košík',
                goBasket: 'Prejsť do košíka',
                greatYouAreGettingFreeDelivery: {
                    text: 'Skvelé! Získavate',
                    uppercase: 'dopravu zadarmo!',
                },
                greatYouAreGettingDiscountedDelivery: {
                    text: 'Skvelé! Získavate',
                    uppercase: 'Zľavu na dopravu!',
                },
                youDoNotHaveANythingInYourBasketYet: 'Vo svojom košíku zatiaľ nič nemáte',
                checkOutOurPriceHits: 'Pozrite sa na naše cenové trháky',
                buyMoreAndGetFreeDelivery1: 'Nakúpte tovar ešte za ',
                buyMoreAndGetFreeDelivery2: ' a dopravu máte zadarmo!',
                showAllProductsInTheCart: 'Zobraziť všetky produkty v košíku',
            },
            menu: {
                transport: 'Doprava',
                club: 'Pilulka klub',
                favorite: 'Moje obľúbené produkty',
            },
            allProducts: 'Zobraziť všetky produkty',
            searchResults: 'Výsledky vyhľadávania',
            seeAllCategory: 'Zobraziť všetko v kategórii',
            sale: {
                title: 'Akcie a zľavy',
                url: '/akcie-a-zlavy',
                more: 'Zobraziť všetky akcie a zľavy',
            },
            christmas: {
                title: 'Vianoce',
                url: '/darceky',
            },
            moreCategories: 'Viac kategórií',
            clinic: {
                url: '/tablet-klinika',
                text: 'Klinika',
            },
            erecept: {
                url: 'https://erecept.pilulka.cz/',
                title: 'Lieky na eRecept',
                text: 'eRecept',
            },
            blackFriday: {
                title: 'Black Friday',
                url: '/black-friday',
            },
            favorite: 'Obľúbené',
            counselling: 'Poradňa',
            pharmacies: 'Lekárne',
            articles: {
                title: 'Články',
                url: '/clanky',
            },
            brands: {
                title: 'Značky',
                url: '/prehlad-znaciek',
                showAllBrands: 'Zobraziť všetky značky',
            },
        },
        searchTern: 'Hľadané výrazy',
        notFound: 'Pre zadaný výraz sa nám nič nepodarilo nájsť. Výraz zmažte alebo upravte.',
        mobileApp: {
            title: 'Aplikácia pre lepší život',
            banner: {
                title: 'Pilulka',
                text: 'Otvoriť v aplikácii Pilulka',
                open: 'otvoriť',
            },
            ios: {
                link: 'https://itunes.apple.com/us/app/pilulka-cz/id1287999800?l=sk&ls=1',
                alt: 'Stiahnuť na App Store',
            },
            android: {
                link: 'intent://play.google.com/store/apps/details?id=cz.pilulka.shop&hl=sk/#Intent;package=cz.pilulka.shop;end',
                alt: 'Stiahnuť na Google Play',
            },
            box: {
                title1: 'Sledujte kuriéra Pilulka Expresu',
                text1: 'Budete vedieť presne kedy vám balíček dorazí',
                title2: 'Odmeňujeme vás za pohyb',
                text2: 'Za pravidelný pohyb od nás dostanete kredity na nákup',
            },
            homepageBanner: {
                easierShoppingWithPilulkaApp: 'Jednoduchšie nakupovanie s aplikáciou Pilulka',
                quickAndRepeatedPurchaseViaOneClick: 'Rýchly opakovaný nákup na jeden klik',
                discountsAndBetterPricesInApp: 'Špeciálne ceny a akcie v aplikácii',
                youKnowExactlyWhereYourOrderIs: 'Presne viete v akom stave a kde je vaša objednávka',
            },
        },
        guarantee: {
            default: 'Garantujeme doručenie do Vianoc.',
            defaultLinkText: 'Zistite viac',
            defaultLink: '/garancia-dorucenie-do-vianoc',
            pilulkaExpress: 'Pilulka Expres',
            pilulkaExpressDate: 'Môžete objednat do 22. 12.',
            pilulkaBox: 'Pilulka Boxy',
            pilulkaBoxDate: 'Môžete objednat do 21. 12. do 12:00',
        },
    },
    footerDictionary: {
        locale: 'sk',
        currency: 'EUR',
        currencySymbol: '€',
        pieces: 'ks',
        closed: 'Zatvorené',
        credits: 'kreditov | kredit | kredity | kreditov',
        showText: 'Zobraziť viac',
        hideText: 'Skryť',
        detail: 'Detail',
        close: 'Zavrieť',
        products: 'Produkty',
        download: 'Stiahnuť',
        loading: 'Načítanie',
        category: {
            title: 'Kategória',
            bestSellers: 'Najpredávanejšie produkty',
        },
        addToCart: 'Do košíka',
        brands: 'Značky',
        gift: 'Darček',
        todayAction: 'Dnešná akčná cena',
        of: 'z',
        url: {
            cartStep1: '/kosik',
            search: '/vyhladavanie',
            category: {
                sale: '/vyprodej',
                saleAndDiscount: '/akcie-a-zlavy',
            },
            static: {
                pilulkaClub: '/pilulka-klub',
            },
            user: {
                login: '/prihlasit-sa',
                logout: '/backend/logout',
                profile: '/konto',
                orders: '/objednavky',
                feedback: '/objednavky',
                myFavorite: '/objednavky',
                forgottenPassword: '/zabudnute-heslo',
                registration: '/registracia',
            },
        },
        downloadApp: 'Stiahnuť Pilulka aplikáciu',
        ios: {
            link: 'https://itunes.apple.com/us/app/pilulka-cz/id1287999800?l=sk&ls=1',
            alt: 'Stiahnuť na App Store',
        },
        android: {
            link: 'https://play.google.com/store/apps/details?id=cz.pilulka.shop&hl=sk',
            alt: 'Stiahnuť na Google Play',
        },
        followUs: 'Sledujte nás\n',
        customerSupport: {
            phoneName: 'Telefon: ',
            phone: '+421 221 025 196',
            whatsAppName: 'WhatsApp: ',
            whatsApp: '+421 947 944 855',
            phoneAvailability: '',
            email: 'info@pilulka.sk',
            emailAvailability: '',
            weWillHelpYou: '',
            generalAvailability: '',
            address: '82104 Bratislava',
            address_street: 'Pestovateľská 3',
            chat: 'Prevádzková doba<br />zákaznické linky',
            contact: '/kontakt',
            chatAvailability: '',
        },
        sukl: {
            footerSukl: {
                url: 'https://prehledy.sukl.cz/prehledy.html#/lekarny/00200820293',
                imagePath: 'https://www.pilulka.cz/images/jpg/cs/sukl.png?v=1679919013',
                alt: 'sukl',
            },
        },
        weRespondEveryWeekday: 'weRespondEveryWeekday',
        advantages: [
            {
                url: '/pilulka-auto',
                imageUrl: '/nuxt-assets/images/icons/usp/autoUsp.svg', // TODO change icons
                title: 'Najlepšie doručenie v Bratislave <br /> Pilulka Expresom',
                isOutlink: true, // todo fix - not working
            },
            {
                url: '/pilulka-box',
                imageUrl: '/nuxt-assets/images/icons/usp/box.svg', // TODO change icons
                title: 'Výdejní Boxy <br /> vyzdvihnutie bez čakania',
            },
            {
                url: '/kontakt',
                imageUrl: '/nuxt-assets/images/icons/usp/contact.svg', // TODO change icons
                title: 'Spoľahlivá zákaznícka <br /> podpora',
            },
            {
                url: '/pilulka-lekarny',
                imageUrl: '/nuxt-assets/images/icons/usp/pharmacy.svg', // TODO change icons
                title: 'Najspoľahlivejšia internetová <br /> lekáreň na Slovensku',
            },
        ],
        linkSections: [
            {
                title: 'Zákaznícka podpora',
                links: [
                    {
                        url: 'https://www.pilulka.sk/kontakt',
                        isOutlink: false,
                        title: 'Kontakt',
                    },
                    {
                        url: 'https://www.pilulka.sk/kontakt',
                        isOutlink: false,
                        title: 'Často kladené otázky',
                    },
                    {
                        url: 'https://www.pilulka.sk/moznosti-dopravy',
                        isOutlink: false,
                        title: 'Možnosti dopravy',
                    },
                    {
                        url: 'https://www.pilulka.sk/moznosti-platby',
                        isOutlink: false,
                        title: 'Možnosti platby',
                    },
                    {
                        url: 'https://www.pilulka.sk/reklamacie-a-vratenie-tovaru',
                        isOutlink: false,
                        title: 'Reklamácia a vrátenie tovaru',
                    },
                    // {
                    //     url: '/moznosti-dopravy',
                    //     isOutlink: false,
                    //     title: 'Možnosti dopravy',
                    // },
                    // {
                    //     url: '/moznosti-platby',
                    //     isOutlink: false,
                    //     title: 'Možnosti platby',
                    // },
                    // {
                    //     url: '/reklamacie-a-vratenie-tovaru',
                    //     isOutlink: false,
                    //     title: 'Reklamácie a vrátenie tovaru',
                    // },
                    // {
                    //     url: '/backend/order/check_state',
                    //     isOutlink: false,
                    //     title: 'Overenie stavu objednávky',
                    // },
                    // {
                    //     url: '/kontakt#faq',
                    //     isOutlink: false,
                    //     title: 'Často sa nás pýtate',
                    // },
                    // {
                    //     url: '/certifikaty-prirodnych-produktov',
                    //     isOutlink: false,
                    //     title: 'Certifikáty prírodných produktov',
                    // },
                    // {
                    //     url: '/kontakt#telefonni-objednavka',
                    //     isOutlink: false,
                    //     title: 'Objednávka po telefóne',
                    // },
                    // {
                    //     url: '/form-recommend',
                    //     isOutlink: false,
                    //     title: 'Dajte nám tip na produkty',
                    // },
                    // {
                    //     url: '/ako-uplatnit-kredity',
                    //     isOutlink: false,
                    //     title: 'Ako uplatniť kredity',
                    // },
                    // {
                    //     url: '/prehlad-znaciek',
                    //     isOutlink: true,
                    //     title: 'Prehľad značiek',
                    // },
                    // {
                    //     url: '/prehlad-produktovych-rad',
                    //     isOutlink: true,
                    //     title: 'Prehľad produktových rád',
                    // },
                ],
            },
            {
                title: 'Jednoduchý nákup',
                links: [
                    {
                        url: 'https://www.pilulka.sk/pilulka-premium',
                        isOutlink: false,
                        title: 'Pilulka Premium',
                    },
                    {
                        url: 'https://www.pilulka.sk/mobilna-aplikacia',
                        isOutlink: false,
                        title: 'Mobilné aplikácie',
                    },
                    {
                        url: 'https://www.pilulka.sk/prehlad-znaciek',
                        isOutlink: false,
                        title: 'Prehľad značiek',
                    },
                    // {
                    //     url: '/pilulka-auto',
                    //     isOutlink: false,
                    //     title: 'Pilulka Expres',
                    // },
                    // {
                    //     url: '/pilulka-lekarny',
                    //     isOutlink: false,
                    //     title: 'Pilulka - osobný odber',
                    // },
                    // {
                    //     url: '/pilulka-box',
                    //     isOutlink: false,
                    //     title: 'Pilulka Box',
                    // },
                    // {
                    //     url: '/pilulka-premium',
                    //     isOutlink: false,
                    //     title: 'Pilulka Premium',
                    // },
                    // {
                    //     url: '/poradna',
                    //     isOutlink: false,
                    //     title: 'Poradňa',
                    // },
                    // {
                    //     url: '/ako-sa-pridat-do-pilulka-recenzneho-klubu',
                    //     isOutlink: false,
                    //     title: 'Recenzný klub',
                    // },
                    // {
                    //     url: '/mobilna-aplikacia',
                    //     isOutlink: false,
                    //     title: 'Mobilná aplikácia',
                    // },
                    // {
                    //     url: '/darcekove-poukazy',
                    //     isOutlink: false,
                    //     title: 'Darčekové poukazy',
                    // },
                    // {
                    //     url: '/pre-firmy',
                    //     isOutlink: false,
                    //     title: 'Pilulka pre firmy',
                    // },
                ],
            },
            {
                title: 'O Pilulke',
                links: [
                    {
                        url: 'https://www.pilulka.sk/o-nas',
                        isOutlink: false,
                        title: 'O nás',
                    },
                    {
                        url: 'https://pracevpilulce.cz/',
                        isOutlink: false,
                        title: 'Pracujte v Pilulke',
                    },
                    {
                        url: 'https://www.pilulka.sk/obchodne-podmienky',
                        isOutlink: false,
                        title: 'Obchodné podmienky',
                    },
                    {
                        url: 'https://www.pilulka.sk/zasady-o-ochrane-osobnych-udajov',
                        isOutlink: false,
                        title: 'Ochrana osobných údajov',
                    },
                    {
                        url: 'https://www.pilulka.sk/pravidla-pouzivania-cookies',
                        isOutlink: false,
                        title: 'Pravidlá používania cookies',
                    },
                    // {
                    //     url: '/kontakt',
                    //     isOutlink: false,
                    //     title: 'Kontakt',
                    // },
                    // {
                    //     url: '/o-nas',
                    //     isOutlink: false,
                    //     title: 'O nás',
                    // },
                    // {
                    //     url: '/pre-media',
                    //     isOutlink: false,
                    //     title: 'Pre médiá',
                    // },
                    // {
                    //     url: '/obchodne-podmienky',
                    //     isOutlink: false,
                    //     title: 'Obchodné podmienky',
                    // },
                    // {
                    //     url: '/zasady-o-ochrane-osobnych-udajov',
                    //     isOutlink: false,
                    //     title: 'Ochrana osobných údajov',
                    // },
                    // {
                    //     url: '/pravidla-pouzivania-cookies',
                    //     isOutlink: false,
                    //     title: 'Pravidlá používania cookies',
                    // },
                    // {
                    //     url: '/affiliate-program',
                    //     isOutlink: false,
                    //     title: 'Affiliate program',
                    // },
                    // {
                    //     url: 'https://www.pracavpilulke.sk',
                    //     isOutlink: true,
                    //     title: 'Pracujte v Pilulke',
                    // },
                    // {
                    //     url: 'https://marketplace.pilulka.sk',
                    //     isOutlink: true,
                    //     title: 'Predávajte na Pilulka.sk',
                    // },
                ],
            },
        ],
        socials: [
            {
                link: 'https://www.facebook.com/pilulka.sk',
                title: 'Facebook',
                icoCssClass: 'ico--footer-fb',
            },
            {
                link: 'https://www.instagram.com/pilulkask',
                title: 'Instagram',
                icoCssClass: 'ico--footer-instagram',
            },
            {
                link: 'https://twitter.com/pilulkask',
                title: 'Twitter',
                icoCssClass: 'ico--footer-twitter',
            },
        ],
        // TODO fix the icons for flags
        flags: [
            {
                code: 'cz',
                url: 'https://www.pilulka.cz',
            },
            // {
            //     code: 'hu',
            //     url: 'https://www.pilulka.hu',
            // },
            // {
            //     code: 'at',
            //     url: 'https://www.pilulka.at',
            // },
        ],
        translations: {
            defaultLanguage: 'sk',
            pageLanguage: 'sk',
            allowed: ['en', 'uk'],
            flags: [
                {
                    code: 'sk',
                    title: 'Slovenský',
                },
                {
                    code: 'en',
                    title: 'English',
                },
                {
                    code: 'uk',
                    title: 'Українська',
                },
            ],
            automaticTranslationWasUsed: 'Na preklad bol použitý automatický preklad. Za prípadné chyby v preklade sa ospravedlňujeme.',
            keepTranslation: 'Ponechať preklad',
            keepTheOriginalWording: 'Nechať pôvodné znenie',
        },
        cookiesText:
            'Pre čo najlepší zážitok z nakupovania. Aby fungovalo správne vyhľadávanie, aby sme si pamätali, čo máte v košíku, aby ste jednoducho zistili stav vašej objednávky, aby sme vás neobťažovali nevhodnou reklamou a aby ste sa nemuseli vždy prihlasovať. Preto od vás potrebujeme súhlas so spracovaním súborov cookie - malých súborov, ktoré sa dočasne ukladajú vo vašom prehliadači v súlade so zákonom č. 452/2021 o elektronických komunikáciách. Ďakujeme, že nám ho dáte a pomôžete nám Pilulku zlepšovať. Budeme sa k vašim dátam chovať citlivo a slušne.',
        recomendedYou: 'Poradíme vám',
        ratingShop: {
            title: 'Hodnotenie',
            rating: 4.8,
            text: 'odporúča nákup na Pilulka.sk',
        },
        getDiscount: 'Najlepšie akcie a zľavy vo vašom e-maile',
        wannaGetDiscount: 'Chcem to',
    },
    basic: {
        maxAmount:
            "V jednej objednávke je možné zakúpiť maximálne {n} ks tohto produktu. Ak potrebujete nakúpiť viac kusov, kontaktujte nás prosím na b2b{'@'}pilulka.sk.",
        maxAmountPerOrder: 'Dosiahnutý limit maximálneho množstva kusov v jednej objednávke.',
    },
    locale: 'sk',
    localeIso: 'sk-SK',
    currency: 'EUR',
    currencySymbol: '€',
    mainTitle: 'Pilulka.sk',
    legalName: 'Pilulka Lékárny a.s.',
    intervalDiscountPrice: '1',
    from: 'z',
    pieces: 'ks',
    closed: 'Zatvorené',
    credits: 'kreditov | kredit | kredity | kreditov',
    showText: 'Zobraziť viac',
    hideText: 'Skryť',
    detail: 'Detail',
    close: 'Zavrieť',
    products: 'Produkty',
    download: 'Stiahnuť',
    loading: 'Načítanie',
    top: 'Hore',
    notImage: 'Nemáme fotku',
    appId: '1287999800',
    stripSpaceSymbol: 'g|ml|mg|l|cps|ks|cpr|pl|mg/ml',
    somethingWentWrong: 'Niečo sa pokazilo',
    homepageTitle: 'Pilulka.sk - Lekáreň pre lepší život',
    metaDescription:
        'Pilulka je najľahšia cesta k zdraviu. Podporujeme prevenciu, udávame trendy moderného lekárenstva a ponúkame všetko pre zdravé telo, sebavedomie aj domov.',
    cookies: {
        ad_storage: 'Reklamné cookies',
        analytics_storage: 'Analytické cookies',
        functionality_storage: 'Funkčné / prevádzkové cookies',
    },
    links: {
        basket: '/kosik',
    },
    askUs: {
        title: 'Opýtajte sa nás',
        yourEmail: 'Váš e-mail',
        yourQuestion: 'Vaša otázka',
        itemsWithAsterisk: 'Položky označené hviezdičkou',
        areRequired: 'sú povinné',
        sendQuestion: 'Odoslať otázku',
    },
    organization: {
        name: 'Pilulka',
        slogan: 'lepší život',
        tel: '+421221025196',
        addressLocality: '',
        postalCode: '',
        streetAddress: '',
    },
    category: {
        title: 'Kategória',
        bestSellers: 'Najpredávanejšie produkty',
        notFoundProductlist: 'Zákazníci najčastejšie kupujú',
        notFoundBannerList: 'Top akcie na Pilulke',
    },
    brands: 'Značky',
    gift: 'Darček',
    todayAction: 'Dnešná akčná cena',
    of: 'z',
    url: {
        cartStep1: '/kosik',
        contact: '/kontakt',
        search: '/vyhladavanie',
        category: {
            sale: '/vyprodej',
            saleAndDiscount: '/akcie-a-zlavy',
        },
        static: {
            pilulkaClub: '/pilulka-klub',
        },
        user: {
            login: '/prihlasit-sa',
            logout: '/backend/logout',
            profile: '/konto',
            orders: '/objednavky',
            feedback: '/hodnotenie',
            myFavorite: '/my-favorite',
            forgottenPassword: '/zabudnute-heslo',
            registration: '/registracia',
            profileSettings: '/informacie-o-pouzivatelovi',
            changePassword: '/zmena-hesla',
            deleteCreditCard: '/backend/user-delete-credit-card',
        },
        complaint: {
            createNew: '/complaint-step1?withdrawal=0',
            homepage: '/complaints',
        },
        counselling: '/poradna',
        mobileApplication: '/mobilna-aplikacia',
        orderRepeat: '/backend/order/repeat',
        cancelOrderByCustomer: '/backend/order/cancel_by_customer',
        prolongOrderByCustomer: '/backend/order/prolong_by_customer',
        pickupPlaceList: '/mapa',
    },
    siteHeader: {
        logoTitle: 'Pilulka.sk - Lekáreň pre vaše zdravie a krásu!',
        basket: 'Košík',
        category: 'Kategória',
        chat: 'Chat',
        search: {
            title: 'Vyhľadať',
            placeholder: 'Hľadajte na Pilulka.sk',
            notfound: 'Skontrolujte prosím vyhľadávané slovo.',
            label: 'Hľadať',
        },
        login: {
            email: 'Váš e-mail',
            password: 'Vaše heslo',
            showPassword: 'Zobraziť heslo',
            sendForgottenPassword: 'Zabudol som heslo',
            title: 'Moja Pilulka',
            label: 'Prihlásiť',
            loginAction: 'Prihlásiť sa',
            loginWithFacebook: 'Prihlásiť cez Facebook',
            loginWithGoogle: 'Prihlásiť cez Google',
            register: 'Registrovať sa',
            favoriteAndRecentlyPurchasedProducts: 'Obľúbené a zakúpené produkty',
            myRatings: 'Moje hodnotenie',
            favoriteProducts: 'Obľúbené produkty',
            reviewClub: 'Recenzný Klub',
            userInfo: 'Osobné údaje',
            credits: '%{credits} kreditov',
            orders: 'Objednávky',
            ratings: 'Hodnotenie produktu',
            myProfile: 'Môj profil',
            logout: 'Odhlásiť sa',
            google: 'Prihlásiť cez Google',
        },
        cartBox: {
            basket: 'Košík',
            cart: 'Košík',
            goBasket: 'Prejsť do košíka',
            greatYouAreGettingFreeDelivery: {
                text: 'Skvelé! Získavate',
                uppercase: 'dopravu zadarmo!',
            },
            greatYouAreGettingDiscountedDelivery: {
                text: 'Skvelé! Získavate',
                uppercase: 'Zľavu na dopravu!',
            },
            youDoNotHaveANythingInYourBasketYet: 'Vo svojom košíku zatiaľ nič nemáte',
            checkOutOurPriceHits: 'Pozrite sa na naše cenové trháky',
            buyMoreAndGetFreeDelivery: 'Nakúpte tovar ešte za %{price} a dopravu máte zadarmo!',
            showAllProductsInTheCart: '- | - | Zobraziť všetky {n} produkty v košíku | Zobraziť všetkých {n} produktov v košíku',
        },
        menu: {
            transport: 'Doprava',
            club: 'Pilulka klub',
            favorite: 'Moje obľúbené produkty',
        },
        allProducts: 'Zobraziť všetky produkty',
        seeAllCategory: 'Zobraziť všetko v kategórii',
        sale: {
            title: 'Akcie a zľavy',
            url: '/akcie-a-zlavy',
        },
        moreCategories: 'Viac kategórií',
        clinic: {
            url: '/pilulka-klinika',
            text: 'Klinika',
        },
        erecept: {
            url: '',
            title: '',
            text: '',
        },
        favorite: 'Obľúbené',
    },
    footer: {
        followUs: 'Sledujte nás',
        customerSupport: {
            phone: '+421 221 025 196',
            phoneAvailability: 'Po - Pia 8:00 - 16:00',
            email: "info{'@'}pilulka.sk",
            emailAvailability: 'Po - Pia 8:00 - 20:00',
            chat: 'Chat',
            chatAvailability: 'Po - Pia 8:00 - 20:00',
        },
        weRespondEveryWeekday: 'weRespondEveryWeekday',
        cookiesText:
            'Pri poskytovaní služieb nám môžu pomáhať súbory cookie. Plne rešpektujeme nastavenia vášho prehliadača. Ak chcete cookie vypnúť, urobte tak vo vašom prehliadači.',
    },
    serviceHomepage: {
        noResultsTitle: 'Vo vašom okolí sme bohužiaľ žiadne kliniky nenašli',
        noResultsText: 'Skúste zmeniť polohu alebo preskúmajte kliniky v ďalších mestách',
        noResultsButton: 'Preskúmať',
    },
    carouselHomepage: {
        title: 'Super ponuka',
        lastViewProducts: 'Naposledy navštívené',
        purchasedProducts: 'Zakúpené produkty',
        basketProducts: 'Uviazlo v košíku',
        wishlistProducts: 'Wishlist',
        topProducts: 'Najobľúbenejšie produkty',
        recentlyPurchasedProducts: 'Vaše skôr zakúpené a obľúbené produkty',
        onePlusOneProducts: 'Akcia 1+1 ZADARMO',
        twoPlusOneProducts: 'Akcia 2+1 ZADARMO',
        lastBoughtRecommendedProducts: 'Vaše obľúbené produkty',
        defaultBannersTitle: 'Vitajte na Pilulke',
    },
    serviceDetail: {
        qualityGuarantee: 'Garancia kvality',
        qualityVariant: 'Varianty služby',
        closestServiceOffice: 'Najbližšia pobočka',
        openToday: 'Dnes otvorené',
        openingHours: 'Otváracia doba',
        showAllOffices: 'Zobraziť všetky pobočky',
        ratingWasAdded: 'Ďakujeme za vaše hodnotenie. Už čoskoro sa objaví pri hodnotenom produkte.',
        reviewRead: 'Prečítať 0 recenzií | Prečítať {n} recenziu | Prečítať {n} recenzie | Prečítať {n} recenzií',
        commentsRead: 'Prečítať 0 recenzií | Prečítať {n} recenziu | Prečítať {n} recenzie | Prečítať {n} recenzií',
        questionRead: 'Zobraziť {number} dotazov',
    },
    search: {
        searchResultsForTerm: 'Výsledky vyhľadávania',
        searchBrands: 'Značky',
        searchCategories: 'Kategorie',
        searchManufacturers: 'Výrobcovia',
        searchProductLines: 'Produktové rady',
        searchPharmacies: 'Lekárne',
        searchServiceOffices: 'Pobočky služieb',
        searchServices: 'Služby',
        searchStaticContents: 'Článok',
    },
    rating: {
        title: 'Hodnotenie',
        shareProductOnFB: 'Zdieľať službu na Facebooku',
        writeRating: 'Napíšte vlastné hodnotenie',
        showAllRatings: 'Zobraziť všetky hodnotenia',
        noRatings: 'Ohodnoťte tento produkt ako prvý.',
        percentCustomersRecommended: '{n}% zákazníkov odporúča',
        users: 'Hodnotilo {n} zákazníkov',
        write: 'Napísať hodnotenie',
        useful: 'Užitočné?',
        login: {
            mustLogin: 'Pre hodnotenie je potrebné <a href="/prihlasit-sa">sa prihlásiť</a> do vášho profilu.',
            signIn: 'Pre hodnotenie je potrebné <a href="/prihlasit-sa">sa prihlásiť</a> do vášho profilu.',
        },
        averageRating: '{n} z 5',
        totalRating: '({n} hodnotenie)',
        showAllRatingTooltip: 'Zobraziť hodnotenie|Zobraziť {n} hodnotenie|Zobraziť {n} hodnotenia|Zobraziť všetkých {n} hodnotení',
    },
    days: {
        monday: 'Pondelok',
        tuesday: 'Utorok',
        wednesday: 'Streda',
        thursday: 'Štvrtok',
        friday: 'Piatok',
        saturday: 'Sobota',
        sunday: 'Nedeľa',
    },
    voucher: {
        boughtVouchers: 'Zakúpené vouchery',
        applied: 'Uplatnený',
        notApplied: 'Neuplatnený',
        noVouchersFound: 'Nemáte žiadne platné vouchery',
        code: 'Kód',
        service: 'Služba',
        validity: 'Platnosť',
        application: 'Uplatnenie',
        serviceOffice: 'Pobočka',
        title: 'Váš voucher',
        validTill: 'Platnosť do {date}.',
        detail: 'Detail služby',
        inPrice: 'V cene',
        howUse: 'Ako uplatniť',
        codeVoucher: 'Kód voucheru',
        validTillLabel: 'Platnosť voucheru',
        useLabel: 'Uplatnenie',
        text1: 'Voucher bol zaslaný na Vami zvolenú emailovú adresu. Pre jeho uplatnenie voucher vytlačte alebo využite jeho online verziu.',
        text2: 'Voucher, jeho číslo alebo vyššie uvedený kód, predložte obsluhe pobočky, na ktorej si prajete službu čerpať.',
        kontakt: {
            title: 'Potrebujete poradiť?',
            tel: '+421 222 703 000',
            open: 'Po - Pi: 8:00 - 16:00',
            mail: 'info@pilulka.sk',
        },
        serviceBox: {
            title: 'Vyhľadanie najbližších pobočiek',
            perex: 'Nastavte svoju adresu pre vyhľadanie najbližších pobočiek.',
            email: 'E-mail',
            tel: 'Tel.',
            detail: 'Detail pobočky',
        },
    },
    userAccount: {
        youDoNotHaveACardYet: 'Nemáte zatiaľ žiadnu kartu',
    },
    serviceManufacturerDetail: {
        services: 'Služby',
        serviceOffices: 'Pobočky',
    },
    productList: {
        noResultsTitle: 'Nenájdené žiadne výsledky',
        noResultsText: 'Požadovaným filtrom bohužiaľ nezodpovedá žiadna služba.',
        noResultsDiscussion: 'Nenájdené žiadne výsledky',
        button: 'Vyhľadať vzdialenejšie služby',
        sort: 'Zoradiť',
        filter: 'Filtrovať',
        filterAndSort: 'Filtrovať a zoradiť',
        sorting: 'Radenie',
        clearFilter: 'Vymazať filtre',
        result: 'Nájdené {totalCount} výsledkov',
        services: 'Služby',
        viewMore: 'Zobraziť ďalšie ponuky',
        branches: 'Pobočky',
        expiration: 'Dátum expirácie',
        perPiece: 'za kus',
    },
    services: {
        nBranchesOffer: 'Neponúka žiadna pobočka | Ponúka {n} pobočka | Ponúka {n} pobočky | Ponúka {n} pobočiek',
    },
    whisperer: {
        showXProducts: 'Zobraziť 0 produktov | Zobraziť 1 produkt | Zobraziť {n} produkty | Zobraziť {n} produktov',
    },
    serviceList: {
        show: 'Zobraziť',
        offersOver10km: 'Ponuky nad 10 km',
    },
    location: {
        yourLocation: 'Vaša aktuálna poloha',
        filter: {
            title: 'OZNAČTE VAŠU POLOHU A MY VÁM UKÁŽEME NAJBLIŽŠIE KLINIKY',
            location: 'Lokalita',
            yourLocation: 'Vaša poloha',
            change: {
                text: 'Zmeniť',
                small: 'polohu',
            },
        },
    },
    maps: {
        link: 'https://mapy.cz/zakladni?x=%{lng}&y=%{lat}&z=17&source=coor&id=%{lng}%2C%{lat}',
    },
    club: {
        title: 'Pripojte sa do Pilulka rodiny',
        text: 'Získajte veľa výhod v našej veľkej rodine',
        buttonText: 'Pripojiť sa',
        url: '/registrácia',
    },
    reviewClub: {
        title: 'Odmeníme vás za každú recenziu',
        desc: 'Pridajte sa do Pilulka Recenzného klubu a buďte súčasťou najväčšej komunity prispievateľov. Podieľajte sa na zlepšovaní obsahu pre všetkých zákazníkov, ktorí nakupujú na Pilulke, a získajte odmenu za to, čo vás baví.',
        textButton: 'Pridať sa do klubu',
        tests: 'Testy',
        review: 'Recenzie | Recenzia | Recenzie | Recenzií',
        clubText:
            'Ako člen <a href="/recenzny-klub" >Pilulka Recenzného klubu</a> môžete na zakúpené produkty pridávať tieto detailné informácie. Pridajte sa k recenzentom a zbierajte odmeny za každý ohodnotený produkt.',
        comments: 'Hodnotenie',
        orders: 'Objednávok',
        recomended: 'Odporúča',
        isEmployee: 'Overený zákazník',
        noEmployeeReview: 'Neoverená recenzia',
        readAllReview: 'Prečítať celú recenziu',
        best: {
            title: 'Najlepšie recenzie',
            recommend: 'odporúča',
            verified: 'Overený zákazník',
            textButton: 'Prečítať celú recenziu',
        },
        reviews: 'Hodnotenie',
        employee: 'Pilulka zamestnanec',
        verified: 'Overený nákup',
        points: 'bodov',
        customerRecommended: 'Zákazník odporúča',
        customerNotRecommended: 'Zákazník neodporúča',
        like: 'Užitočné',
        unlike: 'Neužitočné',
        backToList: 'Späť na výpis',
        readAllReviewFromOurCustomers: 'Prečítajte si všetky recenzie',
        allTitle: '',
        vipReview: 'VIP recenzie',
    },
    mobileApp: {
        title: 'Aplikácia pre lepší život',
        banner: {
            title: 'Pilulka',
            text: 'Otvoriť v aplikácii Pilulka',
            open: 'otvoriť',
        },
        ios: {
            link: 'https://itunes.apple.com/us/app/pilulka-cz/id1287999800?l=sk&ls=1',
            alt: 'Stiahnuť na App Store',
        },
        android: {
            link: 'intent://play.google.com/store/apps/details?id=cz.pilulka.shop&hl=sk/#Intent;package=cz.pilulka.shop;end',
            alt: 'Stiahnuť na Google Play',
        },
        box: {
            title1: 'Sledujte kuriéra Pilulka Expresu',
            text1: 'Budete vedieť presne kedy vám balíček dorazí',
            title2: 'Odmeňujeme vás za pohyb',
            text2: 'Za pravidelný pohyb od nás dostanete kredity na nákup',
        },
        homepageBanner: {
            easierShoppingWithPilulkaApp: 'Jednoduchšie nakupovanie s aplikáciou Pilulka',
            quickAndRepeatedPurchaseViaOneClick: 'Rýchly opakovaný nákup na jeden klik',
            discountsAndBetterPricesInApp: 'Špeciálne ceny a akcie v aplikácii',
            youKnowExactlyWhereYourOrderIs: 'Presne viete v akom stave a kde je vaša objednávka',
        },
    },
    formRecommend: {
        h1: 'Odporučte nám',
        h2: 'Chýba vám na Pilulke obľúbený produkt?',
        p: 'Hľadali ste, ale nenašli – váš produkt na Pilulke skrátka chýba. Môžeme sa ho však pokúsiť zaradiť do ponuky, keď nám o ňom napíšete. Vyplňte prosím formulár nižšie a popíšte nám konkrétne produkty, ktoré by ste na Pilulke chceli vidieť. My si prejdeme vaše nápady a možno svojich obľúbencov čoskoro objavíte aj v našej ponuke. :)',
        h3: 'Napíšte nám',
        fullName: 'Meno a priezvisko:',
        btnText: 'Odoslať tip',
        textarea:
            'Uveďte prosím názov, prípadne popis produktu, ktorý by ste radi videli v našej ponuke, a my urobíme všetko pre to, aby sa tu objavil.',
        agree: {
            text: 'Súhlasím s ',
            url: '/spracovanie-osobnych-udajov',
            link: 'Pravidla ochrany a spracovania osobných údajov.',
        },
        fill: 'Vyplňte prosím všetky polia',
        send: 'Ďakujeme za váš tip!',
    },
    cookiebar: {
        title: 'Aby Pilulka fungovala ako má (súhlas s cookies)',
        text: 'Pre čo najlepší zážitok z nakupovania. Aby fungovalo správne vyhľadávanie, aby sme si pamätali, čo máte v košíku, aby ste jednoducho zistili stav vašej objednávky, aby sme vás neobťažovali nevhodnou reklamou a aby ste sa nemuseli vždy prihlasovať. Preto od vás potrebujeme súhlas so spracovaním súborov cookie - malých súborov, ktoré sa dočasne ukladajú vo vašom prehliadači v súlade so zákonom č. 452/2021 o elektronických komunikáciách. Ďakujeme, že nám ho dáte a pomôžete nám Pilulku zlepšovať. Budeme sa k vašim dátam chovať citlivo a slušne.',
        manageText: 'Spravovať cookies',
        manageLink: '/pravidla-pouzivania-cookies',
        denyText: 'Odmietnuť všetky cookies',
        acceptText: 'Prijať všetky cookies',
        allowSelection: 'Povoliť výber',
        acceptLink: '',
    },
    deliveries: {
        title: 'Možnosti dopravy - Zadarmo od 59 €',
        desc: 'Orientačný čas doručenia, môže sa líšiť v závislosti od vyťaženosti skladu a dopravcov. O presnom termíne vás budeme včas informovať po vytvorení objednávky. ',
        pharmacies: 'Zoznam lekární',
        zasilkovna: 'Zoznam výdajní',
        insertAddressForMoreAccurateDeliveryOptions: 'Zadajte adresu pre presnejšie možnosti doručenia',
    },
    product: {
        insertToCart: 'Vložiť&nbspdo&nbspkošíka',
        addToCard: 'Do košíka',
        preorder: 'Predobjednať',
        forPickupWithinPharmacy: 'Ihneď v lekárni',
        basket: 'V košíku máte {basketAmount}&nbsp;ks za {totalPrice}',
        buyMore: 'Prikúpiť',
        offers: {
            apply: 'Akcia <strong>{n}</strong> aplikovaná.',
            notApply: 'Akcia <strong>{n}</strong>. Na aplikovanie akcie pridajte do košíka potrebné množstvo.',
            buttonAdd: 'Pridať ďalšie|Pridať ďalšie|Pridať {n} kusy|Pridať {n} kusov',
        },
        inPilulkaAppFor: 'V Pilulka aplikácii za: <br /><strong>{price}</strong>',
        downloadApp: 'Stiahnuť aplikáciu',
        downloadAppLink: '/mobilna-aplikacia',
        sponsored: 'Sponzorované',
        productIsPremiumExclusive: 'Len pre Pilulka Premium',
        moreAboutPilulkaPremium: 'Viac o Pilulka Premium',
        action: 'Akcia',
        priceWithPilulkaPremium: 's Pilulka Premium',
        premiumFromXPerMonth: 'Od 1 € / mesiac',
        priceAfterAllDiscounts: 'po zľave',
    },
    reviewForm: {
        title: 'Hodnotenie:',
        service: 'Pobočka:',
        applied: 'Uplatnené:',
        yourRating: 'Vaše hodnotenie:',
        for: 'Pre:',
        against: 'Proti:',
        evaluation: 'Hodnotenie produktu:',
        evaluationText: 'Text hodnotenie:',
        personalData: {
            text: 'Súhlasím s ',
            url: '/spracovanie-osobnych-udajov',
            link: 'Ochrana osobných údajov',
        },
        select: {
            text: 'Položky označené',
            textEnd: 'sú povinné.',
        },
        send: 'Ohodnotiť',
        error: 'Hodnotenie bohužiaľ nebolo pridané',
        thankYou: 'Vaša recenzia bola pridaná, čoskoro sa objaví pri produkte. Ďakujeme!',
    },
    slides: {
        previous: 'Predchádzajúci',
        next: 'Nasledujúce',
    },
    formsElement: {
        fullName: 'Meno a priezvisko',
        email: 'E-mail',
        password: 'Heslo',
        orderNumber: 'Číslo objednávky',
        lastName: 'Priezvisko',
        bankAccount: 'Číslo bankového účtu',
        bankAccountDesc: 'V prípade žiadosti o vrátenie peňazí pošleme peniaze na tento účet',
        verificationCode: 'Overovací kód',
    },
    productDetail: {
        additionalInfoFor: 'Doplňujúce informácie pre',
        additionalInfoAndLeafletFor: 'Doplňujúce informácie a príbalový leták pre',
        reviewsForProduct: 'Recenzie a skúsenosti s produktom',
        showMore: 'Zistiť viac',
        moreAboutPilulkaPremium: 'Viac o Pilulka Premium',
        removeFromBasket: 'Odobrať z košíka',
        addToBasket: 'Pridať do košíka',
        recommendationCarouselTitle: 'Prihoďte si ešte do košíka',
        addToCartPreorder: 'Predobjednať',
        preorder: {
            availabilityText:
                'Predpokladaný termín doručenia je {deliveryDate}. Termín pre vás budeme po dokončení objednávky priebežne aktualizovať.',
        },
        monthlyPackages: {
            title: 'Výhodné balenia',
            monthlyPackage1: {
                title: '1 mesačné balenie',
            },
            monthlyPackage3: {
                title: '3 mesačné balenie',
            },
            monthlyPackage6: {
                title: '6 mesačné balenie',
            },
            freeDelivery: 'Doprava zadarmo',
        },
        plusDeposit: '+ záloha',
        maxAmount:
            "V jednej objednávke je možné zakúpiť maximálne {n} ks tohto produktu. Ak potrebujete nakúpiť viac kusov, kontaktujte nás prosím na b2b{'@'}pilulka.sk.",
        tabs: {
            allTitle: 'Všetko o produkte',
            ratingTitle: 'Hodnotenie produktu',
            weTestedTitle: 'Testovali sme',
            weTestedText: 'Testovali sme my a naši zákazníci',
            leafletTitle: 'Príbalový leták',
            leafletText: 'Príbalovú informáciu môžete stiahnuť tu',
            leafletDownload: 'Príbalové informácie',
            similarTitle: 'Odporúčame vám tieto podobné produkty',
            similarTitleNotInStock: 'Chcete produkt skôr? Vyberte si podobný',
            discussionTitle: 'Otázky',
            discussionText: 'Diskusia k produktu',
            additionalInformation: 'Doplňujúce informácie',
            safetyMessage: 'Bezpečnostné nariadenia: ',
            hygienic: {
                title: 'Upozornenie:',
                text: 'Z hygienických dôvodov tovar nemožno vrátiť, a to ani v lehote 14 dní od zakúpenia.',
            },
            shortExpiryDate: {
                title: 'Upozornenie:',
                text: 'Z dôvodu krátkej expirácie produktu, ho nemožno vrátiť, a to ani v lehote 14 dní od zakúpenia.',
            },
            breastFeeding: {
                title: 'Upozornenie:',
                text: 'Dojčenie je najprirodzenejším spôsobom výživy dojčiat.',
            },
            dietarySupplement: {
                title: 'Upozornenie:',
                text: 'Neprekračujte odporúčané dávkovanie. Výrobok neslúži ako náhrada pestrej stravy.',
            },
            freelyAvailableMedicine: {
                title: 'Upozornenie:',
                text: 'Voľnopredajný liek. Prečítajte si pozorne celú písomnú informáciu skôr, ako začnete tento liek užívať.',
            },
            urlTabs: {
                allTitle: 'vsetko-o-produkte',
                ratingTitle: 'hodnotenie-produktu',
                weTestedTitle: 'testovali-sme',
                leafletTitle: 'pribalovy-lietak',
                similarTitle: 'moze-sa-vam-hodit',
                additionalInformation: 'doplnujuce-informacie',
            },
            productTitleSuffixes: {
                tabReviews: ' - Recenzie a skúsenosti',
                tabLeaflet: ' - Príbalový leták',
                tabDiscussion: '- Diskusia',
            },
        },
        otherManufacturerServices: 'Ostatné služby dodávateľa',
        moreInfo: 'viac info',
        inStock: 'Skladom 5+ks',
        inStockCount: '{n}ks skladom',
        noStock: 'Skladom u dodávateľa',
        outStock: 'Tento produkt nie je momentálne dostupný, zisťujeme informácie od dodávateľa',
        notPurchasable: 'Tento produkt nie je momentálne dostupný.',
        priceOne: 'Cena za 1 ks',
        selectVariant: 'Vybrať variant',
        benefits: 'Benefity',
        certificates: 'Certifikáty',
        writeRating: 'Napísať hodnotenie',
        buy: 'Nákupom získate',
        accessories: 'Príslušenstvo k tovaru',
        quantityDiscount: {
            buyMore: 'Nakúpte viac a ušetrite',
            discount: 'Ušetriť {number} €',
            discountApplying: 'Ušetrené {number} €',
            applied: 'Zvolené',
            tagTitle: 'Zľava od {number} kusov',
        },
        priceUnit: 'EUR/bal.',
        fromPrice: 'od {price}',
        rating: {
            title: 'Hodnotenie produktu',
            rateShowAll: 'Zobraziť ďalšie hodnotenia',
            yes: 'Áno',
            no: 'Nie',
            recommend: 'Zákazník odporúča',
            employee: 'Overený nákup',
            noEmployeeReview: 'Neoverená recenzia',
            showAll: 'Zobraziť všetky hodnotenia',
            noItems: 'Nenašli ste čo ste hľadali?',
            variant: 'Variant',
            allInfo: 'Podľa {n} hodnotenie',
            process: {
                url: '/overovanie-recenzii',
                text: 'Overovanie recenzií',
            },
        },
        ingredients: 'Zloženie',
        superPrice: 'Super cena',
        priceInPharmacy: 'Lekáreň',
        competitorPrice: 'Pilulka Cena',
        competitorPriceDescription: 'Pilulka cena označuje veľmi výhodnú cenu na trhu.',
        xmasDelivery: 'Garantujeme doručenie do Vianoc.',
        xmasDeliveryLink: '/garancia-dorucenie-do-vianoc',
        xmasDeliveryNot: 'Bohužiaľ negarantujeme doručenie do Vianoc.',
        xmasDeliveryInfo: 'Zistite viac',
        productVariants: '- | Zobraziť variantu | {n} varianty | {n} variant',
        priceWithCode: {
            buy: 'Kúpiť s kódom',
            buyInApp: 'Cena s kódom v aplikácii',
            buyWithCode: 'Kúpiť s kódom: {code}',
            withCode: '{price} s kódom {code}',
            withCodeMasterProduct: 'od {price} s kódom {code}',
            withCodeNoPrice: 's kódom {code}',
            withCodeMasterProductNoPrice: 's kódom {code}',
            continuedTag: 'PREDĹŽENÉ',
        },
        benefitPaymentRestriction: 'Nie je možné platiť benefitnými programami',
        mobileAppPrice: {
            ctaPrice: 'Kúpiť so zľavou v aplikácii',
            cta: 'Akcia v aplikácii',
            description: 'v Pilulka Aplikácii',
        },
        giftEvent: {
            withDiscount: 's akciou',
        },
    },
    facebook: {
        sharer: 'https://www.facebook.com/sharer/sharer.php?u=https://www.pilulka.sk/{url}',
    },
    priceInPharmacy: {
        modalTitle: 'Cashback na produkty v lékárně',
        modalText:
            'Nakupte produkty v Pilulka Lékárně a my vám vrátíme zpět až do 100 % ceny produktu ve formě kreditů na váš Pilulka účet. V lékárně stačí ukázat váš kód.',
        modalFirstPoint: 'Až do 100 % ceny produktu zpět',
        modalSecondPoint: 'Více než polovina léků bez doplatku',
        modalThirdPoint: 'Speciální slevy a akce',
        modalFourthPoint: 'Registrace ZDARMA',
    },
    cashback: {
        title: 'Cashback',
        conditions: 'Podmienky cashbacku',
        withPrice: '{price} s cashbackom',
    },
    service: {
        offer: 'Ponuka',
        title: 'Službu môžete využiť iba online, z pohodlia vášho domova',
        nearestBranch: 'Najbližšia pobočka',
        position: 'od&nbsp;Váš',
        tab: {
            allInfo: 'Všetko o službe',
            offices: 'Pobočky',
            comments: 'Hodnotenie',
        },
        validTo: 'Platnosť do',
        inPrice: 'V cene',
        howUse: 'Ako uplatniť',
        service: 'Služby',
        branches: 'Najbližšie pobočky dodávateľa',
    },
    comments: {
        search: 'Hľadajte v hodnoteniach',
        all: 'Všetky',
        verified: 'Len overené',
        automaticallyTranslatedFrom: 'Automaticky preložené z',
        commentFrom: 'Recenzia z',
        showOriginal: 'Zobraziť originál',
        showTranslatedText: 'Zobraziť preložený text',
        originalRating: 'Originálne hodnotenie',
    },
    user: {
        card: 'karta',
        pilulkaCard: 'Vaša Pilulka karta',
        addCard: 'Pridať Pilulka kartu',
        account: 'účet',
        onAccount: 'Na svojom účte máte',
        credits: 'kreditov',
        club: 'Pilulka klubu',
        welcome: 'Vitajte',
        recommendation: {
            url: '/odporúčte-a-zarábajte',
            text: 'Odporučte Pilulku a získajte kredit 50 Kč',
        },
        tabs: {
            orders: 'Objednávky',
            vouchers: 'Vouchery',
            evaluation: 'Moje hodnotenie',
            user: 'Osobné údaje',
            complaint: 'Reklamácia',
            favorite: 'Obľúbené',
            club: 'Recenzný klub',
        },
        howToRedeemCredits: 'Ako uplatniť kredity?',
        creditsHistory: 'História kreditov',
        pilulkaPremiumStaticPageUrl: '/pilulka-premium',
        pilulkaPremiumShowMore: 'Zistiť viac',
        pilulkaPremiumDeactivate: 'Deaktivovať prémiové predplatné',
        pilulkaPremiumDeactivated: 'Predplatné Pilulka Premium bolo deaktivované',
        pilulkaPremiumDeactivateConfirm: 'Naozaj si prajete deaktivovať predplatné premium?',
        pilulkaPremiumActivate: 'Aktivovať prémiové predplatné',
        pilulkaPremiumUsed: 'Využité',
        pilulkaPremiumRemains: 'Zostáva',
        pilulkaPremiumTotallySaved: 'Celkovo ušetrené',
        pilulkaPremiumYourAreNotMember: 'Nie ste členom',
    },
    vouchers: {
        validTill: 'Platnosť do',
        code: 'Kód voucheru',
        inPrice: 'V cene',
        howUse: 'Ako uplatniť',
    },
    dailyOffer: {
        title: 'Hit týždňa',
        end: 'Ponuka končí za',
        pieces: 'Zostáva',
    },
    ddBanner: {
        title: 'Nové zľavy každý deň',
        desc: 'Pozrite sa na tie najlepšie zľavy, ktoré sú práve pre vás',
        btnText: 'Objaviť',
        link: '/akcie-a-zlavy',
    },
    listCategory: {
        viewAll: 'Zobraziť viac kategórií',
    },
    openHours: {
        title: 'Otváracia doba',
    },
    contact: {
        title: 'Kontaktné údaje',
        tel: 'Tel.',
        distance: 'od Vás',
    },
    perex: {
        products: 'produktov',
        more: 'Zobraziť celý popis',
        less: 'Skryť celý popis',
    },
    sideBar: {
        expand: 'Chcem sa objednať',
        sortProduct: 'Zoradiť produkty',
        viewProduct: 'Zobraziť produkty',
        filterProduct: 'Filtrovať produkty',
        search: 'Vyhľadať...',
        clearAll: 'Vymazať všetky filtre',
        send: 'Potvrdiť filtre',
        showList: 'Zobraziť všetko vo filtri',
        hideList: 'Skryť všetko vo filtri',
        notFoundItems: 'Nenájdené žiadne výsledky',
    },
    page: {
        500: {
            title: 'Error 500',
            goToHp: 'Prejsť na úvodnú stránku',
        },
        404: {
            title: 'Stránka sa nenašla',
            perex: 'Ospravedlňujeme sa, ale na tento problém neexistuje žiadna pilulka. Vypadá to, že stránka neexistuje alebo bola premiestnená.',
            goToHp: 'Prejsť na úvodnú stránku',
            subtitle: 'Obľúbené kategórie',
            subcategories: {
                item01: {
                    title: 'Doplnky stravy',
                    url: '/doplnky-stravy',
                    img: '/nuxt-assets/images/png/404/1_kat.png',
                },
                item02: {
                    title: 'Matka a dieťa',
                    url: '/matka-a-dieta',
                    img: '/nuxt-assets/images/png/404/2_kat.png',
                },
                item03: {
                    title: 'Elektro',
                    url: '/elektro',
                    img: '/nuxt-assets/images/png/404/3_kat.png',
                },
                item04: {
                    title: 'Kozmetika',
                    url: '/kozmetika',
                    img: '/nuxt-assets/images/png/404/4_kat.png',
                },
                item05: {
                    title: 'Drogéria',
                    url: '/drogeria',
                    img: '/nuxt-assets/images/png/404/5_kat.png',
                },
                item06: {
                    title: 'Šport',
                    url: '/sport',
                    img: '/nuxt-assets/images/png/404/6_kat.png',
                },
            },
        },
        hp: {
            topCategories: {
                item01: {
                    title: 'Matka a dieťa',
                    img: '/nuxt-assets/images/homepage/topCategories/item01.png',
                    link: '/matka-a-dieta',
                    linkText: 'Objaviť novinky',
                },
                item02: {
                    title: 'Doplnky stravy',
                    img: '/nuxt-assets/images/homepage/topCategories/item02.png',
                    link: '/doplnky-stravy',
                    linkText: 'Pre vašu imunitu',
                },
                item03: {
                    title: 'Kozmetika',
                    img: '/nuxt-assets/images/homepage/topCategories/item03.png',
                    link: '/kozmetika',
                    linkText: 'Starostlivosť o vaše telo',
                },
                item04: {
                    title: 'Drogéria',
                    img: '/nuxt-assets/images/homepage/topCategories/item04.png',
                    link: '/drogeria',
                    linkText: 'Všetko pre vašu domácnosť',
                },
                item05: {
                    title: 'Elektro',
                    img: '/nuxt-assets/images/homepage/topCategories/item05.png',
                    link: '/elektro',
                    linkText: 'Chcem vedieť viac',
                },
            },
            categories: {
                item01: {
                    title: 'Sport',
                    img: '/nuxt-assets/images/homepage/categories/item01.png',
                    link: '/sport',
                    linkText: 'Objaviť novinky',
                },
                item02: {
                    title: 'Potraviny, nápoje',
                    img: '/nuxt-assets/images/homepage/categories/item02.png',
                    link: '/caje-potraviny',
                    linkText: 'Chcem energiu',
                },
                item03: {
                    title: 'Ústa a zuby',
                    img: '/nuxt-assets/images/homepage/categories/item03.png',
                    link: '/usta-a-zuby',
                    linkText: 'Chcem sa otužiť',
                },
                item04: {
                    title: 'Zdravotnický materiál',
                    img: '/nuxt-assets/images/homepage/categories/item04.png',
                    link: '/zdravotnicke-potreby',
                    linkText: 'Objaviť novinky',
                },
                item05: {
                    title: 'Léky',
                    img: '/nuxt-assets/images/homepage/categories/item05.png',
                    link: '/volne-prodejne-leky',
                    linkText: 'Chcem vedieť viac',
                },
                item06: {
                    title: 'Veterina',
                    img: '/nuxt-assets/images/homepage/categories/item06.png',
                    link: '/veterina',
                    linkText: 'Chcem energiu',
                },
                item07: {
                    title: 'Klinika',
                    img: '/nuxt-assets/images/homepage/categories/item07.png',
                    link: '/pilulka-klinika',
                    linkText: 'Chcem energiu',
                },
            },
        },
    },
    paginator: {
        loadMore: 'Ďalších {number} produktov',
    },
    // TODO check these duplicated blocks
    benefitsHomepage: {
        benefit1: {
            url: '/pilulka-auto',
            img: 'https://pilulkacz.vshcdn.net/zoh4eiLi/IMG/86400/1C7caHI9UUPZcNWZN3Itit8RU7l379FpsI7v--Hc07o/aHR0cHM6Ly93d3cucGlsdWxrYS5jei9udXh0LWFzc2V0cy9pbWFnZXMvaWNvbnMvYmVuZWZpdHMvYmVuZWZpdC0wMS14Mi5wbmc.png',
            icon: 'benefit1.svg',
            title: 'Pilulka Expres \n' + 'doručenie \n' + 'v Bratislave a okolí',
        },
        benefit2: {
            url: '/moznosti-dopravy',
            img: '/nuxt-assets/images/box.png',
            icon: 'benefit10.svg',
            title: 'Viac ako 3000\n' + 'odberných miest\n' + 'po Slovensku',
        },
        benefit3: {
            url: '/akcie-a-zlavy',
            img: 'https://pilulkacz.vshcdn.net/zoh4eiLi/IMG/86400/tp9WIbFhRr99eG5dGfFRpKAWzTcTVRkeFNnhYDPGtGY/aHR0cHM6Ly93d3cucGlsdWxrYS5jei9udXh0LWFzc2V0cy9pbWFnZXMvaWNvbnMvYmVuZWZpdHMvYmVuZWZpdC0wNS14Mi5wbmc.png',
            icon: 'benefit7.svg',
            title: 'Široký sortiment\n' + 'produktov skladom',
        },
        benefit4: {
            url: '/mobilna-aplikacia',
            img: 'https://pilulkacz.vshcdn.net/zoh4eiLi/IMG/86400/Y32h_tLySMyZknWJGx7n055aIqAWRKNLs_NNE2Er1WA/aHR0cHM6Ly93d3cucGlsdWxrYS5jei9udXh0LWFzc2V0cy9pbWFnZXMvaWNvbnMvYmVuZWZpdHMvYmVuZWZpdC0wMy14Mi5wbmc.png',
            icon: 'benefit9.svg',
            title: 'Pohodlné nákupy\n' + 'a špeciálne akcie\n' + 's&nbsp;aplikáciou',
        },
    },
    usp: {
        benefit1: {
            icon: 'car1',
            title: 'Doprava ZADARMO pri nákupe nad 59 €',
            // icon: 'certificate',
            // title: 'Najspoľahlivejšia e-lekáreň na Slovensku',
        },
        benefit2: {
            icon: 'users',
            title: 'Viac ako 1 milión spokojných zákazníkov',
        },
        benefit3: {
            icon: 'stock',
            title: 'Cez 20 000 produktov v ponuke skladom',
        },
        benefit1Alternative: {
            icon: 'car1',
            title: 'V mobilnej aplikácii s dopravou ZDARMA',
        },
    },
    uspChristmas: {
        benefit1: {
            icon: 'delivery-circle',
            title: 'Darčeky doručíme ešte dnes',
            url: '/garancia-dorucenie-do-vianoc',
            external: false,
        },
        benefit2: {
            icon: 'christmas-return-circle',
            title: 'Nevhodný darček vymeníme zadarmo',
            url: '/reklamacie-a-vratenie-tovaru',
            external: false,
        },
        benefit3: {
            icon: 'christmas-circle',
            title: 'Všetky darčeky na jednom mieste',
            url: '/darceky-na-vianoce',
            external: false,
        },
        benefit4: {
            icon: 'christmas-card-circle',
            title: 'Každodenná nádielka<br> v Adventnom PilulKalendári',
            url: 'https://www.instagram.com/pilulkask/',
            external: true,
        },
    },
    pagination: {
        loadMore: 'Načítať ďalších {number}',
    },
    discussions: {
        title: 'Nenašli ste odpoveď? Spýtajte sa',
        button: 'Položiť otázku',
        verifiedCustomer: 'Overený zákazník',
        pilulkaSpecialist: 'Pilulka expert',
        specialist: 'Expert',
        answers: 'Odpovedí',
        questions: 'Otázok',
        respond: 'Odpovedať',
        askQuestion: 'Položiť otázku',
        mustLogin: 'Pre účasť v diskusii je potrebné sa prihlásiť do vášho profilu.',
        newAnswer: 'Upozorniť na novú odpoveď',
        watching: 'Sledovať',
        watchingDiscussions: 'Sledovať diskusiu',
        unWatching: 'Prestať sledovať diskusiu',
        newest: 'Najnovšie',
        oldest: 'Najstaršie',
        mostRelevant: 'Najužitočnejšie',
        watchAnswer: 'Nenašli ste odpoveď? Spýtaj sa nás',
        search: 'Hľadať v diskusiách',
        btnShow: 'Zobraziť diskusie v kategórii',
        report: 'Nahlásiť',
        closeAnswer: 'Skryť {n} odpoveď',
        close: 'Zavrieť',
        open: '- | Zobraziť {n} odpoveď | Zobraziť {n} odpovede | Zobraziť {n} odpovedí',
        useful: 'Užitočné?',
        send: 'Položiť otázku',
        rules: 'Pravidlá diskusie',
        agree: 'Položiť otázku',
        questionText: 'Text dotazu',
        questionName: 'Názov dotazu',
        formValidatorTitleEmpty: 'Napíšte prosím názov',
        formValidatorTextEmpty: 'Napíšte prosím text správy',
        formValidatorProductDiscussionTermsOfUseEmpty: 'Pre vloženie dotazu je nutné súhlasiť s podmienkami diskusie.',
        yourAnswer: 'Tvoja odpoveď',
        formValidatorReasonEmpty: 'Zadajte prosím dôvod hlásenia.',
        formValidatorEmailEmpty: 'Prosím vyplňte váš e-mail',
        login: {
            signIn: 'prihlásiť',
            mustLogin: 'Pre účasť v diskusii je potrebné sa <a href="/prihlasit-sa">prihlásiť</a> do vášho profilu.',
        },
        loginUrl: '/prihlasit-sa',
        thankYou: 'Ďakujeme',
        successfullyReported: 'Nevhodný obsah bol úspešne nahlásený.',
        ratingPost: 'Hodnotenie príspevku',
        reason: 'Upozorniť na nevhodný obsah',
        reasons: {
            reportReasonInappropriate: 'Nevhodný/nerelevantní obsah',
            reportReasonInaccurate: 'Nepřesné či špatné informace',
            reportReasonCopyright: 'Autorsky chráněný obsah',
            reportReasonDuplicate: 'Duplicitní obsah',
            reportReasonOther: 'Jiné',
        },
        messageReport: 'Správa (tu popíšte dôvod vášho upozornenia)',
        yourMail: 'Váš e-mail',
        backToListProducts: 'Späť na výpis produktov',
        rulesModal: {
            title: 'Pravidlá diskusií na Pilulka.sk',
            text: `<p>
                Služba <strong>Pilulka Diskusie</strong> umožňuje prihláseným užívateľom zverejňovať názory a otázky k danej téme
                (produkt, služba), reagovať na názory ďalších užívateľov a hodnotiť názory ďalších užívateľov.
            </p>
            <h3>Dôležité dokumenty</h3>
            <p>Pred vstupom do diskusie odporúčame preštudovať tieto dôležité dokumenty:</p>
            <ul>
                <li><a href="/zmluvne-podmienky-diskusii-na-pilulka-sk">Zmluvné podmienky diskusií</a></li>
                <li><a href="/obchodne-podmienky">Všeobecné obchodné podmienky</a></li>
                <li><a href="/zasady-o-ochrane-osobnych-udajov">Spracovanie osobných údajov</a></li>
            </ul>
            <h3>Vstup do diskusie</h3>
            <p>Vstup do diskusie vám bude umožnený za týchto podmienok:</p>
            <ul>
                <li>
                    Máte účet na Pilulka.sk. Do diskusií je nutné sa prihlasovať s účtom na Pilulka.sk. Pokiaľ zatiaľ účet nemáte, môžete si ho založiť <a href="/registracia">tu</a>.
                </li>
                <li>
                    Súhlasíte so zmluvnými podmienkami služby Pilulka Diskusie, ktoré sú kedykoľvek prístupné na tomto odkaze
                    <a href="/zmluvne-podmienky-diskusii-na-pilulka-sk"
                    >https://www.pilulka.sk/zmluvne-podmienky-diskusii-na-pilulka-sk</a
                    >.
                </li>
            </ul>
            <h3>Banovanie</h3>
            <p>
                Užívatelia, ktorí budú porušovať <a href="/zmluvne-podmienky-diskusii-na-pilulka-sk">zmluvné podmienky</a> služby
                Pilulka Diskusie, dostanú tzv. ban. Tj. bude im na určitú dobu (v niektorých prípadoch aj navždy) znemožnený vstup do
                diskusií na stránkach Pilulka.sk. Povinnosťou správcov Pilulka Diskusií je tiež mazať príspevky, ktoré odporujú
                <a href="/zmluvne-podmienky-diskusii-na-pilulka-sk">zmluvným podmienkam</a>.
            </p>
            <p>Banujeme e-mailovú adresu.</p>
            <h3>Problémy s prihlásením</h3>
            <p>Ak sa prihlásenie do účtu nepodarí, odporúčame:</p>
            <ul>
                <li>vypnúť doplnky blokujúce reklamu</li>
                <li>opustiť anonymné okno</li>
                <li>prihlásiť sa v inom prehliadači</li>
            </ul>
            <p>
                V prípade pretrvávajúceho problému kontaktujte našu zákaznickú linku. Kontakty nájdete na našich stránkách v sekcii
                <a href="/kontakt">Kontakt</a>.
            </p>`,
        },
        termsOfUse:
            'Súhlasím so spracovaním <a href="/zmluvne-podmienky-diskusii-na-pilulka-sk" target="_blank">osobných údajov a podmienkami diskusie</a>',
        url: '/diskusia',
        titleSuffix: 'Diskusia',
    },
    reviews: {
        reviewsAndExperience: 'recenzie a skúsenosti',
        btnShow: 'Zobraziť recenzie v kategórii {feedName}',
        rating: 'Ľudia hodnotia produkty v kategórii {feedName} na {rating} %',
        title: '{feedName} - recenzie a skúsenosti zákazníkov',
        url: '/recenzie-skusenosti',
        description:
            'Zaujíma vás, aké skúsenosti majú s produktmi {feedName} ostatní zákazníci? Mrknite sa na ich recenzie, nech nekupujete mačku vo vreci.',
        productRating: '<b>Recenzia produktu:</b> {productName}',
        showProduct: 'Pozrieť produkt',
    },
    prebasket: {
        title: 'A máte to v košíku!',
        tocart: 'Prejsť do košíka ',
        nostock: 'Tento produkt nie je skladom, očakávame, že bude skladom %dateText% Dodanie sa môže oneskoriť.',
        continue: 'Pokračovať v nákupe',
        fastCheckout: 'Fast checkout',
        freeShipping: 'Doprava zadarmo',
        freeShippingTitle: 'Koľko chýba do dopravy zadarmo?',
        freeShippingLeft: 'Zostáva len: ',
        discountedShipping: 'Získavate zľavu na dopravu!',
        discountedShippingTitle: 'Koľko chýba do zľavy na dopravu?',
        notAddOnProducts: 'Zákazníci zvyčajne s týmto produktom kupujú tiež:',
        minOrderPrice: 'Do minimálnej hodnoty objednávky ostáva',
    },
    substitutions: {
        title: 'Pilulka.sk odporúča tieto produkty',
    },
    attributes: {
        isRecommended: 'Pilulka odporúča',
    },
    erotic: {
        taskAge: 'Som starší ako 18 rokov',
        yesAge: 'Pokračovať',
        noAge: 'Nie som starší ako 18 rokov',
        imageAlt: 'Vy ste nad 18 rokov',
    },
    notFound: {
        category: 'V tejto kategórii neboli nájdené žiadne produkty.',
        box1: {
            title: 'Nenašli ste, čo ste hľadali?',
            desc: 'Pošlite nám tip na produkt a my ho skúsime zaradiť do ponuky.',
            btnText: 'Odporučiť produkt',
        },
        box2: {
            title: 'Potrebujete poradiť?',
            desc: 'Napíšte nám a radi vám pomôžeme s výberom a vyhľadávaním vhodného produktu.',
            btnText: 'Opýtajte sa nás',
        },
    },
    reviewModal: {
        title: 'Ako pravdepodobné je, že by ste odporučil/a Pilulku vašim blízkym?',
        thankYouNote: 'Ďakujeme za hodnotenie. Chcete nám povedať podrobnosti?',
        completelyUnlikely: 'úplne nepravdepodobné',
        completelyLikely: 'veľmi pravdepodobné',
        ratingText: 'Text hodnotenia - nepovinné',
        feedbackForm: '',
        sendRating: 'Odoslať hodnotenie',
        feedbackSent: 'Spätná väzba bola úspešne pridaná. Ďakujeme',
        alreadyRated: 'Túto službu ste už predtým ohodnotili.',
        thankYouForRating: 'Ďakujeme za hodnotenie!',
        formLink: '',
        googleRating: 'Pomôžte nám zlepšiť naše služby a ohodnoťte nás aj na Google.',
        googleCta: 'Udeliť hodnotenie',
    },
    showInfo: 'Zobraziť celý popis',
    giftsActions: {
        more: 'Podmienky akcie',
    },
    warningMessage: 'Informácie o akcii',
    pilulkaCar: {
        verifyAvailability: 'Overiť dostupnosť',
        goShopping: 'Ísť nakupovať',
        changePostCode: 'Zmeniť PSČ',
        validationTitle: 'Zadajte PSČ pre doručenie Pilulka Expresom',
        postCode: 'PSČ',
        validationCta: 'Overiť PSČ',
        selectDifferentShipping: 'Výber iného druhu dopravy',
        validPostcode: 'Na zadanou PSČ doručujeme',
        notValidPostcode: 'Na zadané PSČ bohužiaľ nedoručujeme',
        selectedPostCode: 'Doručenie sa uskutoční na PSČ {postcode}',
        changeAddressOrDelivery: 'Zmeniť adresu alebo zvoliť iný spôsob dopravy',
        slots: {
            free: 'Zadarmo',
            weWontMakeItInTime: 'Nestihneme',
            select: 'Potvrdiť',
            occupied: 'Obsadené',
            available: 'Voľno',
        },
    },
    competitorPrice: {
        modalTitle: 'Super cena',
        sale: 'U nás ušetríte',
        competitor: 'Najčastejšia cena konkurencie',
        pilulka: 'Super cena Pilulka.sk',
        date: 'Naposledy aktualizované dne',
    },
    productSubstitutions: {
        title: 'Máme pre vás lepší produkt',
        badge: 'Výhodnejšie balenie',
        keepCurrentProduct: 'Ponechať aktuálnu možnosť',
        chooseBetterProduct: 'Vybrat výhodnejšie balení',
    },
    dynamicBundles: {
        title: 'Nakupujte spoločne',
        discount: 'Ušetríte {discount}',
        totalPrice: 'Cena celkom:',
        changeProduct: 'Zmeniť produkt',
        chooseProduct: 'Vybrať produkt',
        cta: 'Kúpiť spoločne',
    },
    trust: {
        showTrust: false,
        headline: '',
        title1: '',
        text1: '',
        title2: '',
        text2: '',
        title3: '',
        text3: '',
        title4: '',
        text4: '',
        review: '',
        textReview: '',
        linkTrustBadge: '',
    },
    listPayMethods: [],
    giftAction: {
        addProductText: 'Pridajte ďalší produkt.',
        addProductTextWithDiscount: 'Pridajte ďalší produkt a získajte zľavu {discount} %',
        conditionMet: 'Vaša zľava je aplikovaná v košíku.',
    },
    chatBot: {
        category: [],
        brand: [],
        productLine: [],
        product: [],
        url: [],
    },
    basket: {
        migration: {
            title: 'Dokončiť nákup v aplikácii',
            ctaPrice: 'V aplikácii {price}',
            cta: 'Akcie v aplikácii',
            qrImg: '/qr-cart-migrate-to-mobile/{basketUid}',
            qrAlt: 'Naskenujte kód QR',
            migrateLink: '/cart-migrate-to-mobile?basketUid={basketUid}',
            migrateCta: 'Prenest košík so zľavami do aplikácie',
            step1: 'Stiahnite si Pilulka Aplikáciu a zaregistrujte sa',
            step2: 'Pomocou našej QR čítačky v mobilnej aplikácii naskenujte QR kód nižšie. Košík sa vám otvorí priamo v&nbsp;aplikácii aj so&nbsp;zľavou.',
            step2MObile: 'Kliknite na tlačítko nižšie. Košík sa vám otvorí priamo v aplikácii aj so zľavou.',
            step3: 'Dokončite nákup v aplikácii a ušetrite ',
        },
    },
    referralProgram: {
        title: 'Zľava 10 %',
        subtitle: 'pre váš ďalší nákup v aplikácii',
        shareLink: 'Zdieľajte nás s 3 priateľmi a my vás odmeníme hneď, ako u nás nakúpia',
        shareButton: 'Kopírovať odkaz',
        coppied: 'Skopírované',
    },
    articles: {
        url: '/clanky',
        widgetTitle: 'Články',
        widgetListButton: 'Všetky články',
        filterTitle: 'Filtrovať články',
        sortTitle: 'Zoradiť články',
        sortSubmitLabel: 'Zobraziť články',
        tags: 'Štítky',
        readArticle: 'Prečítať',
        paginator: {
            loadMore: 'Ďalších {n} článkov | Ďalších {n} článkov | Ďalších {n} článkov | Ďalších {n} článkov',
        },
    },
    askYourPharmacist: {
        title: 'Spýtajte sa lekárnika',
        text: 'Odborné rady a odpovede na vaše otázky, a to z pohodlia vášho domova.',
        addQuestion: 'Položiť otázku',
        showAllQuestions: 'Všetky otázky',
        search: 'Hľadať',
    },
    paperAuthor: {
        paperAuthor: 'Autor článku',
        allArticlesOfAuthor: 'Všetky články od autora',
    },
    pharmacy: {
        listLink: '/pilulka-lekarny',
        pilulkaPharmacies: 'Pilulka Lekárne',
        listTitle: 'Široká sieť odberných miest po celom Slovensku',
        listDescription: 'Navštívte naše odberné miesta po celom Slovensku. Vyberte si vašu najbližšiu lekáreň.',
        searchByLocation: 'Načítať polohu',
        enterAddress: 'Zadať adresu',
        openRightNow: 'Práve otvorené',
        pilulkaPickupPlace: 'Výdajné miesto Pilulka.sk',
        inPilulkaClub: 'Zapojená v Pilulka Klube',
        showPharmacyDetail: 'Zobraziť detail lekárne →',
        orderPickup: 'Vyzdvihnutie objednávky',
        closed: 'Zatvorené',
        pharmacyDetail: 'Detail lekárne',
        pharmacyList: 'Seznam lékáren',
        pharmacyMapList: 'Mapa lékáren',
        isOpenedNow: 'Lekáreň je práve otvorená',
        isClosedNow: 'Lekáreň je práve zatvorená',
        isSamplingPoint: 'Prijíma rezervácie z eshopu',
        contact: 'Kontakt',
        address: 'Adresa',
        phone: 'Telefon',
        email: 'E-mail',
        ereceptRezervation: 'Rezervovať eRecept',
        navigate: 'Navigovať',
        openingHours: 'Otváracia doba',
        openingHoursInfo: 'Počas sviatkov sa otváracia doba môže líšiť. Prosíme kontaktujte lekáreň telefonicky na uvedenom čísle.',
        aboutPharmacy: 'O lekárni',
        pharmacyManagement: 'Vedenie lekárne',
        chiefPharmacist: 'Vedúci lekárnik',
        nearestPharmacies: 'Najbližšie lekárne',
        detailBenefits: {
            benefit2: {
                title: 'Spýtajte sa lekárnika',
                description: 'Odborné rady a odpovede <br /> na všetky vaše otázky',
                backgroundImagePath: '/nuxt-assets/images/pharmacy/pharmacy-detail-benefit-2.png',
                ctaUrl: '/poradna',
                ctaText: 'Vstúpiť do Poradne',
            },
        },
        showAllPharmacies: 'Zobraziť všetky lekárne',
        badges: {
            benefits: 'Prijímame platbu benefity',
            wheelchairAccess: 'Bezbariérový <br /> prístup',
            dermocosmetics: 'Dermokozmetika',
            diabetesScreening: 'Screening diabetu',
            homeopathy: 'Homeopatia',
            drugCounseling: 'Liekové <br /> poradenstvo',
            preparingMedicinesAccordingToRecipes: 'Príprava liekov <br /> podľa recepto',
            healthyFood: 'Zdravá výživa',
            healthShoes: 'Zdravotná obuv',
            quittingSmoking: 'Odvykanie od fajčenia',
            veterina: 'Veterina',
            medicalSupplies: 'Zdravotnícke <br /> potreby',
            parkingInFrontOfThePharmacy: 'Parkovanie pred <br /> lekárňou',
            creditCardPayment: 'Platba kartou',
            involvementInThePilulkaClub: 'Zapojenie do <br /> Pilulka Klubuu',
        },
        showFullOpeningHours: 'Zobraziť celú otváraciu dobu',
        hideFullOpeningHours: 'Skryť celú otváraciu dobu',
        availabilityProducts: 'Dostupnosť produktu na lekárňach',
        enterName: 'Zadajte názov lekárne',
        pharmacyName: 'Názov lekárne',
        pharmacyAddress: 'Adresa lekárne',
        quantity: 'Počet kusov',
        pharmacyPriceInfo: 'Cena v Lekárni sa môže líšiť. Presnú cenu sa dozviete priamo v Lekárni.',
    },
    pickupPlace: {
        mapLink: '/mapa?map-type=',
        mapTitle: 'Mapa',
        zasilkovna: 'Packeta',
        post_office: 'Slovenská pošta',
        ppl_parcelshop: 'PPL ParcelShop',
        gls_parcelshop: 'GLS ParcelShop',
        pilulka_box: 'Pilulka Box',
        contactInfo: 'Kontaktné údaje',
        location: 'http://www.google.com/maps/place/',
        showOnMap: 'Otvoriť v mapách',
        openingHours: 'Otváracia doba',
        opened: 'Otvorené',
        closed: 'Zatvorené',
        onMap: 'na mape',
        today: 'Dnes',
        pickupOrder: 'Vyzdvihnutie objednávky',
        whereBox: 'Kde box nájdem?',
        parkingInfo: 'Kde zaparkovať?',
        boxLocation: 'Umiestnenie boxu',
        howOpenBox: 'Ako box otvoriť?',
        boxInstructions:
            'Na Pilulka Boxe nájdete jednoduchý návod ako otvoriť schránku s vašou objednávkou. Vyzdvihnutie je možné len s nainštalovanou aplikáciou vo vašom chytrom telefóne.',
        openingTrouble: 'Máte problém s otvorením?',
        anyProblem: 'Pokiaľ pri vyzdvihnutí nastane akýkoľvek problém, neváhajte sa obrátiť na našu zákaznícku podporu.',
        anyProblemCall: 'Zavolať 221 025 196',
        anyProblemPhone: 'tel:+421221025196',
        anyProblemWrite: "Poslať email na info{'@'}pilulka.sk",
        anyProblemEmail: "mailto:info{'@'}pilulka.sk",
    },
    bothersMe: {
        list: 'Čo vás trápi?',
        description:
            'Trápia vás niektoré z nižšie uvedených problémov? Vybrali sme niekoľko liekov, ktoré by vám mohli pomôcť. Ak vám tu bude niečo chýbať, prosím kontaktujte nás, a my sa vám budeme snažiť vyjsť v ústrety.',
        bothersMe: 'Trápi ma',
    },
    map: {
        lat: '48.6796505',
        lng: '19.2437246',
    },
    contactFormValidation: {
        email: 'Vyplňte prosím platný e-mail.',
        message: 'Vyplňte prosím správu.',
        notSubmitted: 'Formulár nebol odoslaný, kontaktujte prosím vyvojari@pilulka.cz.',
    },
    counselling: {
        title: 'Poradňa',
        homepageLink: '/poradna',
        listLink: '/spytajte-sa-lekarnika',
        askPharmacist: 'Spýtajte sa lekárnika',
        questionIsAnsweredBy: 'Na otázku odpovedá:',
        questionFromDate: 'Otázka z {date}',
        showAnswer: 'zobraziť odpoveď',
        backToCounsellingHomepage: 'Späť do poradne',
        askQuestion: 'Položiť otázku',
        askYourOwnQuestion: 'Položte vlastnú otázku',
        didntFindWhatYouWereLookingFor: 'Nenašli ste, čo ste hľadali?',
        articles: 'Články',
        allArticles: 'Všetky články',
        allQuestions: 'Všetky otázky',
        mostSearchedTopics: 'Najhľadanejšie témy',
        similarQuestions: 'Podobné otázky',
        recentQuestions: 'Najnovšie otázky',
        ourPharmacists: 'Naši lékárnici',
        theMostPopularProductsFromOurPharmacies: 'Najobľúbenejšie produkty z našich lekární',
        shopMoreTopics: 'zobraziť viac tém',
        searchInputPlaceholder: 'Vyhľadať otázku',
        metaDescription:
            'Opýtajte sa lékárnika na čokoľvek, čo vás zaujíma. Odborné rady a odpovede na vaše otázky, a to z pohodlia vášho domova.',
        list: {
            filterTitle: 'Filtrovať otázky',
            sortTitle: 'Zoradiť otázky',
            sortSubmitLabel: 'Zobraziť otázky',
            tags: 'Štítky',
        },
        benefits: {
            // benefit1: {
            //     title: 'Rezervujte eRecepty online',
            //     description: 'Lieky na predpis si zarezervujete z pohodlia domova',
            //     backgroundImagePath: '/nuxt-assets/images/counselling/counselling-benefit-1.png',
            //     ctaUrl: 'https://erecept.pilulka.cz',
            //     ctaText: 'Rezervovať',
            //     ctaTarget: '_blank',
            // },
            benefit2: {
                title: 'Široká sieť Pilulka Lekární',
                description: 'Navštívte naše kamenné lekárne po celej SR',
                backgroundImagePath: '/nuxt-assets/images/counselling/counselling-benefit-2.png',
                ctaUrl: '/pilulka-lekarny',
                ctaText: 'Preskúmať',
                ctaTarget: '_blank',
            },
        },
        upsertModal: {
            title: 'Spýtajte sa lekárnika',
            warning:
                'V prípade otázky na objednávku, dostupnosť tovaru a služby e-shopu kontaktujte zákaznícku podporu, kontaktný formulár nájdete na <a href="/kontakt">tejto stránke</a>.',
            yourEmail: 'Váš e-mail',
            titleOfQuestion: 'Nadpis otázky',
            text: 'Text otázky',
            textPlaceholder: 'Nepodpisujte sa svojím menom. Otázky sú anonymné.',
            send: 'Odoslať otázku',
            successMessage: 'Ďakujeme. Otázka bola odoslaná. Po jej zodpovedaní vás notifikujeme e-mailom.',
            errors: {
                emailRequired: 'Vyplňte prosím svoj e-mail',
                emailInvalid: 'Vyplňte prosím platný e-mail',
                titleRequired: 'Vyplňte prosím nadpis otázky',
                textRequired: 'Vyplňte prosím text otázky',
                checkboxRequired: 'Pre odoslanie otázky musíte súhlasiť s podmienkami spracovania osobných údajov',
                titleCannotIncludeAt: "Nadpis otázky nemôže obsahovať znak {'@'}",
            },
            checkboxAgreeText:
                'Súhlasím so <a href="/zasady-o-ochrane-osobnych-udajov" target="_blank">spracováním osobných údajov</a> a <strong>so zverejnením svojej otázky v poradni.</strong>',
        },
        paginator: {
            loadMore: 'Ďalších {n} otázok | Ďalšia {n} otázka | Ďalšie {n} otázky | Ďalších {n} otázok',
        },
        recommendations: {
            productsTitle: 'Odporúčané produkty',
            categoriesTitle: 'Odporúčané kategórie',
        },
    },
    cart: {
        url: {
            step1: '/kosik',
            step2: '/kosik-2',
            step3: '/kosik-3',
            step4: '/objednavka-odoslana',
        },
        nextStep: {
            backDefault: 'Späť',
            back: 'Späť do obchodu',
            toStep2: 'Pokračovať na dopravu a platbu',
            backStep2: 'Späť na dopravu a platbu',
            sendOrder: 'Odoslať objednávku',
            backStep1: 'Späť do košíka',
            continue: 'Pokračovať',
            continueToPersonalInfo: 'Pokračovať na osobné údaje',
            withPaymentObligation: 's povinnosťou platby',
        },
        basket: 'Košík',
        gift: 'Darček',
        progressBar: {
            deliveryPay: 'Doprava a platba',
            informationUser: 'Informácie o vás',
            finish: 'Ďakujeme',
        },
        totalPrice: {
            priceWithVat: 'Celková cena s DPH:',
            savePrice: 'Celkom ušetríte',
            freeDelivery: 'Doprava zdarma',
            discountDelivery: 'Zľava na dopravu',
            rounding: 'Zaokrouhlení',
            shipping: 'Doprava',
        },
        step1: {
            title: 'Objednávka',
            empty: {
                title: 'Váš košík je zatiaľ prázdny',
                continueShopping: 'Ísť nakupovať',
            },
            mobileAppOrderStreak: {
                creditCoefficient: '0.01',
                inMobileApp: 'V mobilnej aplikácii môžete získať <strong>{credits} kreditov ({amount})</strong>',
                finishOrderInMobileApp: 'Nakúpiť v aplikácii',
                openApp: 'Preniesť košík do aplikácie',
                steps: {
                    step2: 'Pomocou našej QR čítačky v mobilnej aplikácii naskenujte QR kód nižšie. Košík sa vám otvorí priamo v aplikácii.',
                    step2Mobile: 'Kliknite na tlačidlo nižšie. Košík sa vám otvorí priamo v aplikácii.',
                    step3: 'Nakúpte v aplikácii a získajte za svoj nákup {credits} kreditov ({amount}).',
                },
            },
            mobileAppOrderMigration: {
                inMobileAppFor: 'V aplikácii za',
                finishOrderInMobileApp: 'Dokončiť nákup v aplikácii',
                android: {
                    link: 'https://play.google.com/store/apps/details?id=cz.pilulka.shop&hl=cs',
                    alt: 'Stiahnuť na Google Play',
                },
                ios: {
                    link: 'https://itunes.apple.com/us/app/pilulka-cz/id1287999800?l=cs&ls=1',
                    alt: 'Stiahnuť na App Store',
                },
                qrAlt: 'Naskenujte QR kód',
                openApp: 'Preniesť košík so zľavou do aplikácie',
                steps: {
                    step1: 'Stiahnite si Pilulka Aplikáciu a zaregistrujte sa',
                    step2: 'Pomocou našej QR čítačky v mobilnej aplikácii naskenujte QR kód nižšie. Košík sa vám otvorí priamo v&nbsp;aplikácii aj so&nbsp;zľavou.',
                    step2Mobile: 'Kliknite na tlačítko nižšie. Košík sa vám otvorí priamo v aplikácii aj so zľavou.',
                    step3: 'Dokončite nákup v aplikácii a ušetrite',
                    step3Voucher: 's kódom {voucherCode}',
                    step3LimitOncePerUser: '(Zľava je uplatniteľná iba raz)',
                },
            },
            recommendationCarouselTitle: 'Pripojte si ešte do košíka',
            csr: {
                checkboxLabel: 'Chcem prispieť na dobrú vec',
                modalTitle: 'Pomáhajte s nami',
                addToOrder: 'Pridať k objednávke',
                moreInfo: 'Viac info',
                confirm: 'Potvrdiť',
            },
            availableNoWarehouseProductsWarning:
                'Niektoré produkty nie sú aktuálne skladom, dostupnosť overujeme u dodávateľa. Doručenie objednávky sa preto môže zdržať. Skúste ich nahradiť produktmi, ktoré máme skladom.',
            unavailableProductsWarning:
                'Niektoré produkty nie sú aktuálne dostupné. Skúste ich nahradiť produktmi, ktoré máme skladom. Ak ich nenahradíte, budú z košíka odstránené.',
            substitutions: {
                buttonText: 'Nahradiť',
                buttonTextLong: 'Nahradiť skladovým',
                productIsNotInStock:
                    'Ospravedlňujeme sa, ale produkt <a href="{productUrl}" target="_blank" class="text-primary">{productName}</a> <strong style="color: #ff7f41">{productAvailability}</strong>',
                productIsNotAvailable: 'Ospravedlňujeme sa, ale produkt {productName} nie je k dispozícii',
                modalTitle: 'Nahradenie produktu',
                modalPerex: 'Produkt môžete nahradiť a mať objednávku skôr doma.',
                deleteFromBasket: 'Odstrániť z košíka',
                leaveWithDelivery: 'Ponechať s doručením {date}',
            },
            credits: {
                useXCredits: '-|Použiť {n} kredit|Použiť {n} kredity|Použiť {n} kreditov',
                useCredits: 'Chcete použiť kredity?',
                modal: {
                    title: 'Chcete použiť svoje kredity?',
                    text: 'Kredity je možno použiť iba v našej aplikácii. Stiahnite si našu aplikáciu a použite kredity na zníženie ceny objednávky.',
                    bestApp: 'Najlepšie hodnotená aplikácia',
                    reviewTitle: 'Perfektné',
                    review:
                        'Dokonalá a prehľadná aplikácia, veľký výber možností dopravy a platby.\n' +
                        ' Široká ponuka produktov. Odporúčame.',
                    ratingValue: '4,8',
                    ratingOutOf: 'z 5',
                    ratingTotal: 'Hodnotenie: 31,4k',
                },
            },
            voucher: {
                title: 'Máte darčekový poukaz?',
                inputPlaceholder: 'Vložte poukaz',
                button: 'Použiť poukaz',
            },
            lastBoughtRecommendedProductsCarouselTitle: 'Vaše obľúbené produkty',
            discountRecommendedProductsCarouselTitle: 'Obľúbené produkt',
            raiffeisenBankDiscount: {
                title: 'Jedinečná zľava od Raiffeisen banky',
                info: 'To je iba začiatok! Okrem 3€ zľavy z nákupu Vás automaticky zaradíme aj do žrebovania o 20 x 100€ darčekovú poukážku na Pilulka.sk. Neváhajte, využitie tejto limitovanej ponuky je jednoduché:',
                checkboxEnabledText:
                    'Súhlasím s <a href="https://www.raiffeisen.sk/files/archiv/pilulkla-2024/sutaznepodmienky_OkamzitazlavasRaiffeisenbankou_2024.pdf" target="_blank">podmienkami súťaže</a> o zaradenie do žrebovania o 20 x 100€ darčekové poukazy. Pre účely súťaže poskytne spoločnosť Pilulka spoločnosti Raiffeisen banka vaše osobné údaje, ktoré ste vyplnili pri objednaní tovaru v časti Informácie o vás.',
                marketingNotificationsCheckboxEnabledText:
                    'Súhlasím so <a href="https://www.raiffeisen.sk/files/archiv/pilulkla-2024/Raiffeisen_marketingovysuhlas.pdf" target="_blank">spracovaním osobných údajov Raiffeisen bankou</a> za účelom informovania o produktoch, službách a inováciách banky. Zároveň vyhlasujem, že mám aspoň 16 rokov.',
                warning: 'Pokiaľ chcete využiť zľavu 3 € na nákup s Raiffeisenbank musíte súhlasiť s podmienkami akcie.',
            },
        },
        step2: {
            title: 'Objednávka',
            goodsWillBeDeliveredToAddressWithPostCode: 'Doručenie na adresu PSČ',
            shipping: {
                title: 'Vyberte si spôsob dopravy',
                changeShipping: 'Zmeniť dopravu',
                changePilulkaExpresTime: 'Zmeniť čas doručenia',
                selectPilulkaExpresTime: 'Zmeniť čas doručenia',
                from0: 'od 0 €',
                personalPickupShippingGroupsTitle: 'Odberné miesta',
                homeDeliveryShippingGroupsTitle: 'Doručenie na adresu',
            },
            payment: {
                title: 'Vyberte si spôsob platby',
                changePayment: 'Zmeniť platbu',
                saveCreditCard: 'Zapamätať kartu',
                useOtherCreditCard: 'Použiť inú kartu',
                useCreditCard: 'Použiť kartu {cardNumberMask}',
                secureCreditCardInfo: 'Zabezpečené',
                secureCardInfo:
                    'Uloženie platobnej karty je 100% bezpečné. Vaše platobné údaje nie sú nikdy ukladané priamo u nás, ale u nášho certifikovaného poskytovateľa platobných služieb, ktorý spĺňa najprísnejšie bezpečnostné štandardy.',
            },
            yourLastPickupPlaces: 'Vaše posledné miesta',
            pickupPlaceList: 'Zoznam miest',
            place: {
                selectPlace: 'Vyzdvihnem tu',
                showDetails: 'Podrobnosti',
                closed: 'Zatvorené',
                notPlacesFound: 'Žiadne výsledky',
                occupied: 'Obsadené',
                boxIsFull: 'Box je plne obsadený. Vyberte prosím iné odberné miesto.',
                boxIsDisabledDueToSafetyReasons: 'Niektoré vybrané produkty nie je bezpečné do boxu doručiť',
            },
            loginModal: {
                title: 'Prihlásenie',
                rememberCardAlertMessage: 'Pre zapamätanie platobnej karty sa prosím prihláste',
                incorrectLogin: 'Zadali ste zlý e-mail alebo heslo',
            },
            map: {
                defaultLat: 48.6796505,
                defaultLng: 19.5937246,
            },
            homeDeliveryModal: {
                title: 'Doručenie na adresu',
                submit: 'Potvrdiť adresu',
                insertPostCode: 'Zadajte PSČ kam chcete objednávku doviezť',
                street: 'Ulica',
                city: 'Mesto',
                postCode: 'PSČ',
                selectPilulkaExpres: 'Chcem výhodnejšiu dopravu Pilulka Expres',
                selectOtherDeliveries: 'Chcem zvoliť iného dopravcu',
                choosePilulkaExpresSlot: 'Vyberte čas pre doručenie dopravou Pilulka Expres',
                chooseShipping: 'Vyberte dopravcu',
                invalidPostCode: 'Zadajte prosím platné PSČ',
                invalidStreet: 'Zadajte prosím ulicu',
                invalidCity: 'Zadajte prosím mesto',
                filterConfirm: 'Potvrdiť',
                filterButton: 'Filtrovať',
                pilulkaDeliveries: 'Pilulka dopravy',
                otherDeliveries: 'Externé dopravy',
                unavailable: 'Nedostupné',
                pilulkaExpresIsNotAvailableForThisPostCode:
                    'Doprava Pilulka Expres bohužiaľ nie je dostupná pre vaše PSČ. Vyberte si prosím iného dopravcu.',
            },
            insertAddress: 'Zadajte adresu',
            selectShippingWarning: 'Najprv zvoľte dopravu a platobnú metódu',
            selectPilulkaExpresSlot: 'Vyberte čas doručenia pre Pilulka Expres',
            selectPaymentWarning: 'Najprv zvoľte platobnú metódu',
            selectPickupPlace: 'Najprv zvoľte odberné miesto',
            payCardOnDeliveryInfo:
                'Upozorňujeme, že naši vodiči neprijímajú z bezpečnostných dôvodov hotovostné platby, preto môžete platiť iba platobnou kartou. Ďakujeme za pochopenie.',
        },
        step4: {
            title: 'Objednávka odoslaná',
            thankYou: 'Ďakujeme',
            yourOderNumber: 'Vašu objednávku č.',
            yourReservationNumber: 'Vašu rezerváciu č.',
            weAcceptedCorrectly: 'sme v poriadku prijali.',
            weSentSummary: 'Na e-mail sme Vám zaslali zhrnutie a ozveme sa Vám s ďalším postupom.',
            status: 'Stav',
            paid: 'Zaplatená',
            unpaid: 'Čaká na zaplatenie',
            paymentInProcess: 'V spracovaní',
            contactUs:
                'Všetky dôležité informácie sme Vám poslali e-mailom, pokiaľ by ste ale čokoľvek potrebovali, pokojne zavolajte alebo napíš.',
            checkOutApp: 'Vyskúšajte aplikáciu Pilulka',
            downloadApp: 'Stiahnite si našu aplikáciu a získajte akčné ceny a exkluzívne ponuky len pre vás.',
            ratingUs: 'Ako by ste ohodnotili proces objednania na webe pilulka.sk?',
            terribleRating: 'hrôza',
            excellentRating: 'skvelé',
            ratingSentError: 'Pri odosielaní hodnotenia sa vyskytla neočakávaná chyba',
            ratingSentSuccess: 'Hodnotenie bolo úspešne odoslané',
            yourOrder: 'Váš nákup',
            totalPriceWithVat: 'Celková cena vrátane DPH',
            delivery: 'Doprava',
            free: 'Zadarmo',
            payment: 'Platba',
            voucher: 'Zľavový kupón',
            pieces: 'ks',
            beware: 'Pozor!',
            estimatedDateBankTransfer:
                'Pri platbe bankovým prevodom sa tovar z objednávky zablokuje až po pripísaní platby na náš účet. Potom vám upresníme aj dátum doručenia.',
            bankAccountAt: 'Bankový účet vedený v',
            variableSymbol: 'Variabilný symbol',
            amount: 'Čiastka',
            qrCode: 'QR code',
            qrCodePaying: 'Zaplaťte pomocí QR kódu',
            qrCodePayingDescription:
                'Prihláste sa do bankovej aplikácie vašej banky, zvoľte platbu QR kódom, oskenujte a už len potvrďte bezpečnostným prvkom. Rýchlo a pohodlne.',
            confirmoDetails: 'Prohlédnout detaily platby',
            expiredPayments:
                'Kurz krypto měn se rychle mění, je tedy třeba platbu realizovat relativně rychle (cca do 15min od založení). Pokud vyexpiruje, objednávku již nepůjde zaplatit a bude stornována.',
            protectingNature: 'Chránime prírodu a preto nebalíme produkty do žiadnych ďalších obalov.',
            carGame: 'Skôr ako vám to privezieme, môžete sa posadiť za volant nášho vozidla Pilulka',
            moreZasilkovna: 'Viac o Zásielkovni',
            morePharmacy: 'Viac o lekárni',
            carGameLink: '/pilulka-car-game/game.html',
            contact: 'Kontaktné údaje',
            address: 'Adresa',
            foodSupplementCalendarReminder: {
                title: 'Nezabudnite si včas objednať ďalšie balenie',
                text: 'Aby vám suplementy nedošli práve vo chvíli, keď ich najviac potrebujete, pridajte si pripomienku do kalendára. Stačí jedno kliknutie a máte pokoj.',
                buttonText: 'Pridať do kalendára',
            },
        },
        step3: {
            title: 'Objednávka',
            addonSale: {
                modalTitle: 'Špeciálna ponuka iba pre vás!',
                modalPerex:
                    'Ako poďakovanie za dokončenie objednávky vám ponúkame jedinečnú ponuku zostavenú na mieru priamo vám. Urobte si radosť za výhodnejšiu cenu!',
                modalEmptyButton: 'Už nič nepridávať',
                modalButton: 'Dokončiť objednávku',
            },
            altDelivery: {
                modalTitleNoPreference: 'Vybrali sme pre Vás Pilulka Expres',
                modalTitle: 'Využite službu Pilulka Expres',
                willUseCurrentShipping: 'Nechcem, využijem súčasného dopravcu',
                upForExpress: 'Chcem doručiť Pilulka Expresom',
                confirmSlot: 'Potvrdiť zvolený čas',
                chooseDifferentSlot: 'Vyberte iný slot',
                followCurrier: 'Sledovanie pohybu kuriéra v mobilnej aplikácii. Presne viete, kedy príde.',
                dontWait: 'Nečakajte celý deň, prídeme načas',
                expressEffective: 'Pilulka Expres nestojí nič naviac',
                selectTime: 'Vyberte si čas doručenia Pilulka Express',
                inExactTime: 'Vašu objednávku doručíme v presnom čase:',
            },
            informationAboutYou: 'Informácie o vás',
            firstName: 'Meno',
            lastName: 'Priezvisko',
            phone: 'Mobilný telefón',
            email: 'E-mail',
            address: 'Adresa',
            street: 'Ulica a popisné číslo',
            city: 'Mesto',
            postCode: 'PSČ',
            company: 'Názov firmy',
            note: 'Poznámka k objednávke',
            insertInvoiceDetails: 'Požadujem vystaviť faktúru na firmu',
            ico: 'IČ',
            dic: 'DIČ',
            icDph: 'IČ DPH',
            insertDeliveryAddress: 'Požadujem inú adresu doručenia',
            delFirstName: 'Meno',
            delLastName: 'Priezvisko',
            delStreet: 'Ulica a popisné číslo',
            delCity: 'Mesto',
            delPostCode: 'PSČ',
            delCompany: 'Spoločnosť',
            delPhone: 'Mobilný telefón pre kuriéra',
            firstNameRequired: 'Vyplňte prosím meno',
            lastNameRequired: 'Vyplňte prosím priezvisko',
            emailRequired: 'Vyplňte prosím e-mail',
            phoneRequired: 'Vyplňte prosím mobilný telefón',
            phoneInvalid: 'Vyplňte prosím platné telefonné číslo',
            streetRequired: 'Vyplňte prosím ulicu a popisné číslo',
            cityRequired: 'Vyplňte prosím mesto',
            companyRequired: 'Vyplňte prosím názov firmy',
            postCodeRequired: 'Vyplňte prosím PSČ',
            icoRequired: 'IČO musí byť 8-miestne číslo.',
            dicRequired: 'Zadali ste IČ DPH, ktoré nie je platné',
            dicValidationPattern: '^(\\w{10,12})?$',
            icDphRequired: 'Vyplňte prosím IČ DPH',
            delFirstNameRequired: 'Vyplňte prosím meno',
            delLastNameRequired: 'Vyplňte prosím priezvisko',
            delStreetRequired: 'Vyplňte prosím ulicu a popisné číslo',
            delCityRequired: 'Vyplňte prosím mesto',
            delPostCodeRequired: 'Vyplňte prosím PSČ',
            delPhoneRequired: 'Vyplňte mobilný telefón pre kuriéra',
            firstNameLatinOnlyError: 'Vyplňte prosím meno bez špeciálnych znakov',
            lastNameLatinOnlyError: 'Vyplňte prosím priezvisko bez špeciálnych znakov',
            emailValidationErrors: {
                BAD_DOMAIN: 'Zlá alebo neexistujúca doména e-mailovej adresy',
                MAILBOX_NOT_FOUND: 'Poštová schránka neexistuje',
                FULL_INBOX: 'Poštová schránka je plná, takže e-maily nemožno doručiť',
                BAD_SYNTAX: 'Zadajte e-mail v správnom tvare',
                TEMPORARY: 'Dočasná chyby e-mailovej validácie',
                ACCEPT_ALL_POLICY:
                    'Existencia e-mailovej adresy nie je istá, pretože doména nám nedovolí vykonať úplné overenie kvôli tomu, že prijíma všetky e-maily',
                DISABLED_MAILBOX: 'E-mailová adresa je zadaná správne, ale cieľový server nedovoľuje na túto adresu doručovať poštu',
            },
            agreementText:
                'Potvrdzujem, že som sa oboznámil s <a href="{termsAndConditionsLink}" class="tdu" target="_blank">obchodnými podmienkami</a> a s <a href="{privacyPolicyLink}" class="tdu" target="_blank">Ochranou osobných údajov</a> a súhlasím s nimi.',
            agreementTextOtc:
                'Potvrdzujem, že som sa oboznámil s <a href="{termsAndConditionsLink}" class="tdu" target="_blank">obchodnými podmienkami</a> a s <a href="{privacyPolicyLink}" class="tdu" target="_blank">Ochranou osobných údajov</a> a súhlasím s nimi.',
            termsAndConditionsLink: '/obchodne-podmienky',
            privacyPolicyLink: '/zasady-o-ochrane-osobnych-udajov',
            termsAndConditionsAdditionalText: '',
            noteAdditionalTextPilulkaExpress:
                'Tu nám môžete uviesť poznámky týkajúce sa:<ul><li>produktov alebo fakturácie</li><li>bližšie upresnenia miesta doručenia pre vodičov Pilulka Expres</li></ul>',
            noteAdditionalText:
                'Tu nám môžete uviesť napr.:<ul><li>farebnú variantu alebo vzor produktu, ktorý na základe ponuky požadujete</li><li>informáciu v prípade, že si prajete hradiť na zálohovú faktúru</li></ul>',
            notePlaceholderPilulkaExpress:
                'Tu nám môžete uviesť bližšie upresnenia miesta doručenia pre vodičov Pilulka Expres. Zľavový kód nie je možné do objednávky vkladať spätne.',
            notePlaceholder:
                'Poznámka k objednávke slúži iba ako doplňujúca informácia pre e-shop a nedokážeme ju predať dopravcom. Zľavový kód nie je možné do objednávky vkladať spätne.',
            phonePrefix: 'Predvoľba',
            phoneNumber: 'Telefónne číslo',
            phoneDefaultCountry: 'SK',
            phoneCountryLocale: 'sk-SK',
            phoneExample: 'napríklad:',
            conditionsRequired: 'Prosíme o súhlas so spracovaním osobných údajov',
            marketingCheckboxLabel: 'Neprajem si byť informovaný/á o exkluzívnych ponukách a často nakupovaných produktoch',
            streetDoesNotContainNumber: 'Zadajte číslo popisné',
            searchCountry: 'Zadajte krajinu',
            requiredField: 'Povinné pole*',
        },
        login: {
            title: 'Máte už účet?',
            description_1: 'Prihláste sa',
            description_2: ' a majte všetky svoje objednávky prehľadne na jednom mieste.',
            email: 'Váš e-mail',
            password: 'Vaše heslo',
            withoutLogin: 'Chcem pokračovať bez prihlásenia.',
            googleLinkCart2: '/social-login/google?redirect_uri=%2Fkosik-2',
            googleLinkCart3: '/social-login/google?redirect_uri=%2Fkosik-3',
            verificationCode: 'Overovací kód',
        },
        premiumBox: {
            subscriptionNotice: 'Pilulka Premium predlžujeme automaticky. Zrušiť predplatné môžete kedykoľvek vo svojom profile.',
            premium: 'Pilulka Premium',
            title: 'Doručenie ZADARMO a prémiové zľavy',
            info: 'Využívajte dopravu zdarma do výdajných miest, boxov a na Pilulka Lekárne.',
            infoMobile: 'Využívajte dopravu zdarma do výdajných miest, boxov a na Pilulka Lekárne.',
            moreInfo: 'Viac info',
            notInterested: 'Nemám záujem',
            month: 'mesiac',
            wantPremium: 'Chcem Pilulka Premium',
            averageSaving: 'Bežná rodina u nás nakúpi 12x za rok. Vďaka Pilulka Premium je možné za dopravu ušetriť až 23,88 €.',
            modalDisclaimer:
                'Pilulka Premium sa vzťahuje iba na e-mail, na který sa vytvorí objednávka. Pilulka Premium nie je možné preniesť na iný e-mail, vrátiť ho ani reklamovať.',
        },
    },
    complaint: {
        homepageTitle: 'Reklamácie',
        productsTitle: 'Reklamovaný tovar',
        createNewComplaint: 'Vytvoriť novú reklamáciu',
        title: 'Reklamácie a vrátenie tovaru',
        titleComplaint: 'Reklamácie',
        titleReturning: 'Vrátenie tovaru',
        myComplaints: 'Moje reklamácie',
        complaintDetail: 'reklamace/{id}',
        detailTitle: 'Detail reklamácie',
        returnCta: 'Vrátiť tovar',
        complaintCta: 'Reklamovať',
        step1: 'Objednávka',
        step2: 'Produkt',
        step3: 'Formulár',
        step4: 'Odoslané',
        complaintTitleOrderSelectProducts: 'Vyberte produkt k reklamácii - objednávka č. {orderNumber}.',
        returningTitleOrderSelectProducts: 'Vyberte produkt na vrátenie - objednávka č. {orderNumber}.',
        returningWarning:
            'Prosíme Vás, označte balíček číslom objednávky ({orderNumber}) alebo vložte do balíčka faktúru. Bez toho nemusí byť reklamácia vybavená.',
        invoiceDownload: 'Stiahnuť faktúru',
        backCta: 'Späť',
        continueCta: 'Pokračovať',
        continueCtaSelectProduct: 'Vyberte produkt k reklamácii',
        continueCtaSelectProductReturn: 'Vyberte produkt na vrátenie',
        continueReturnCtaSelectProduct: 'Vyberte produkt na vrátenie',
        reasonComplaint: 'Typ reklamácie',
        finishForm: 'Dokončiť reklamáciu',
        finishFormReturn: 'Dokončiť vrátenie',
        nonReturnableProduct: 'Nie je možné vrátiť',
        changeReason: 'Zmeniť typ reklamácie',
        selectShipping: 'Ako si prajete tovar doručiť',
        changeShipping: 'Zmeniť dopravu',
        userInfoDetail: 'Podrobnosti reklamácie',
        userDescriptionPlaceholder: 'Pre rýchlejšie odbavenie popíšte váš problém čo najpodrobnejšie.',
        selectFiles: 'Nahrať súbory',
        selectedFiles: 'Vybrané súbory:',
        filesInfo: 'Nahrajte súbory, ktoré chcete k reklamácii priložiť',
        sent: 'Vaša reklamácia č. {complaintNumber} bola úspešne odoslaná',
        howToPackage: 'Ako správne zabaliť tovar pri posielaní k nám?',
        productsComplaint: 'Produkt k reklamácii',
        contacting: 'Čoskoro vás budeme kontaktovať e-mailom alebo telefonicky s ďalšími informáciami na spracovanie vašej reklamácie.',
        instruction: {
            step1: 'Pripravte produkt',
            step1Description:
                'Aby sme mohli výrobok prijať na reklamáciu, musí byť výrobok zaslaný čistý, vrátane všetkého príslušenstva a uvedený do továrenského nastavenia. Ak tieto podmienky nebudú splnené, reklamácia nemusí byť prijatá.',
            step2: 'Vyberte vhodný obal',
            step2Description:
                'Odporúčame krabicu, v ktorej vám zásielka od nás prišla, pokiaľ nie je poškodená. Ak krabicu ešte nemáte, vyberte vhodnú veľkosť a hrúbku krabice s ohľadom na zasielaný výrobok.',
            step3: 'Produkt v krabici vhodne zabezpečte',
            step3Description:
                'Prázdny priestor v krabici vyplňte výplňovým materiálom (napr. polystyrénom, bublinkovou fóliou, novinami). Oddeľte tovar od okrajov krabice výplňovým materiálom zo všetkých strán vrátane dna a vrchnej časti krabice, aby ste zabránili jeho poškodeniu pri preprave.',
            step4: 'Krabicu starostlivo uzavrite a označte.',
            step4Description:
                'Krabicu starostlivo uzavrite, zalepte lepiacou páskou a viditeľne ju označte číslom objednávky, v ktorej bol výrobok zakúpený. Za prepravu reklamovaného tovaru zodpovedá zákazník. Ak bude reklamácia uznaná, budú vám preplatené náklady na dopravu. Ak nie je možné vyplniť reklamáciu online, použite formulár na odstúpenie od zmluvy.',
        },
        goShopping: 'Prejsť na nakupovanie',
        complaintsOverview: 'Prehľad reklamácií',
        complaintsOverviewUrl: '/complaints',
        withoutLogin: 'Reklamácia/Odstúpenie od zmluvy neprihlásený',
        loginDescription:
            'Po prihlásení do svojho účtu môžete ľahšie vyhľadať svoje objednávky a vytvoriť reklamáciu alebo odstúpiť od zmluvy.',
        withoutLoginDescription: 'Zadajte číslo objednávky a svoje priezvisko uvedené na objednávke.',
        whereReturnProducts: 'Kam vrátiť tovar?',
        returnAddress: {
            name: 'Pilulka Lékárny a.s.<br>Schranka c. 23',
            street: 'Pošta Bratislava 22, Kašmírská 7',
            postCode: '820 02 Bratislava 22',
            phone: 'tel.: +421 221 025 196',
            email: "e-mail: reklamacie{'@'}pilulka.sk",
        },
        externalService: {
            title: 'Ako postupovať',
            description:
                'Pre čo najrýchlejšie a najjednoduchšie vybavenie reklamácie odporúčame zaslať výrobok priamo autorizovanému servisu.',
            alertText: 'Nezabudnite priložiť faktúru preukazujúcu nákup výrobku v spoločnosti Pilulka',
            detail: 'Reklamovanú závadu spíšte čo najpodrobnejšie. Kontaktujte autorizovaný servis, viď informácie nižšie, a dohodnite sa na doručení výrobku.',
            buttonCtaService: 'Chcem svoju reklamáciu vybaviť rýchlo prostredníctvom servisu',
            buttonCtaPilulka: 'Chcem svoju reklamáciu vybaviť pomalšie prostredníctvom Pilulka',
        },
        addressModal: {
            title: 'Zmeniť adresu na vyzdvihnutie tovaru',
            current: 'Aktuálna adresa',
            currentEmpty: 'Nie je vyplnená',
            new: 'Nová adresa na vyzdvihnutie',
            firstName: 'Meno',
            lastName: 'Priezvisko',
            street: 'Ulica a číslo popisné',
            city: 'Mesto',
            zip: 'PSČ',
            company: 'Názov firmy',
            keepCurrent: 'Ponechať adresu',
            confirm: 'Potvrdiť',
            error: 'Uistite sa, že ste vyplnili všetky požadované polia',
        },
        datePicker: {
            title: 'Dátum vyzdvihnutia',
            selectDate: 'Vyberte dátum',
            select: 'Potvrdiť',
            pickupWillBe: 'Vyzdvihnutie sa uskutoční dňa',
        },
        zasilkovnaInfo:
            'Balíček zabalte dle instrukcí, označte číslem objednávky a na podacím místě Zásilkovny nahlaste číslo <b>94579772</b>. Náklady spojené s přepravou hradíme my. Upozorňujeme, že dodání tímto přepravcem může trvat i 10 dní. Použitím výše zmíněného kódu souhlasíte s prodloužením reklamační lhůty o 10 dní. Pro rychlejší vyřízení vyberte jiného dopravce.',
        bankAccount: 'Číslo účtu',
        pickupWillBe: 'Vyzdvihnutie na {address} dňa {date}',
        pickupWillBePilulkaCar: 'Vyzdvihnutie na {address} dňa {date} v {time}',
        fillAddress: 'Vyplňte adresu vyzdvihnutia',
        selectSlot: 'Vyberte slot pre vyzdvihnutie',
        changePickupDate: 'Zmeniť čas vyzdvihnutia',
        changePickupSlot: 'Zmeniť čas vyzdvihnutia',
        changeAddress: 'Zmeniť adresu',
        deliveryBackAlert: 'Vyplnenú reklamáciu vám zašleme späť s použitím rovnakej zásielky a adresy ako pri pôvodnej objednávke.',
        returnAlert: 'Všetky náklady spojené s doručením tovaru v lehote 14 dní od zakúpenia platíte vy ako odosielateľ.',
        complaintDetailTitle: 'Podrobnosti reklamácie',
        complaintDetailDescription: 'V prípade, že sa reklamácia vyrieši vrátením peňazí, pošleme peniaze na nasledujúci účet',
        contactDepartment: "Pre viac informácií nás kontaktujte na reklamacie{'@'}pilulka.sk",
        recommendShipping: {
            title: 'Ako doručiť reklamovaný tovar?',
            description: '',
            descriptionReturning: '',
            packeta: {
                title: 'Packeta',
                description: 'Balík odovzdáte na podacom mieste Packety. Upozorňujeme, že doručenie k nám trvá 5 až 10 dní od podania.',
                howToSend: 'Ako poslať tovar prostredníctvom Packety',
                howToSendUrl: 'https://www.zasilkovna.cz/odeslani',
                image: '/images/png/sprites/delivery-2.png?v=1',
            },
            dpd: {
                title: 'DPD',
                description: 'Kurýr DPD vyzvedne balíček na vámi zvolené adrese.',
                howToSend: 'Jak objednat svoz DPD.',
                howToSendUrl: 'https://www.dpd.com/cz/cs/poslat-balik',
                image: '/images/png/sprites/dpd.png?v=2',
            },
        },
        ordersNotEligible: 'Nenašli jsme objednávky, které byste mohl reklamovat',
        waitingForComplaint: "V prípade dodatočných otázok nám napíšte na reklamacie{'@'}pilulka.sk",
        orderInvoice: 'Faktúra k objednávke',
        weWillGetBack: 'Ozveme sa vám čo najskôr a doriešime všetky detaily vašej reklamácie.',
        userDescriptionRequired: 'Vyplňte prosím Podrobnosti reklamácie',
        differentDeliveryMethod: 'Iná / vlastná doprava',
        differentDeliveryMethodDescription: 'Na doručenie tovaru na náš sklad môžete využiť ľubovoľného dopravcu.',
    },
    login: {
        title: 'Prihlásenie',
        login: 'Prihlásiť sa',
        sendForgottenPassword: 'Zaslať zabudnuté heslo',
        findOrder: 'Vyhľadať objednávku',
        viaGoogle: 'Prihlásiť cez Google',
    },
    chat: {
        url: ['kontakt', 'kontakt-2'],
    },
    popUp: {
        forNewCustomers: 'Prihláste sa a získajte',
        getDiscountHtml: 'najlepšie akcie a zľavy<br /> do e-mailu',
        getDiscount: 'najlepšie akcie a zľavy do e-mailu',
        yourEmail: 'Váš e-mail',
        nwlDisagree: 'Neprajem si byť informovaný/á o exkluzívnych ponukách a často nakupovaných produktoch',
        iAgree: 'Súhlasím so',
        termsAndCondition: 'Obchodné podmienky',
        termsAndConditionUrl: '/obchodne-podmienky',
        andWith: 'a s',
        processingData: 'spracovaním osobných údajov',
        processingDataUrl: '/zasady-o-ochrane-osobnych-udajov',
        registerAndGetDiscount: 'Prihlásiť',
        registrationComplete:
            'Na dokončenie prihlásenia na odber newslettera prosím potvrďte svoj e-mail kliknutím na odkaz, ktorý sme vám práve poslali. Ďakujeme.',
        query: 'pop-up-registration',
    },
    targito: {
        trgid: 'trgid_pilulka_sk',
        trgm: 'trgm_pilulka_sk',
        trgd: 'trgd_pilulka_sk',
    },
    watchdog: {
        title: 'Strážiť dostupnosť’',
        description: 'Hneď ako bude produkt k dispozícii, upozorníme vás e-mailom.',
        ctaModal: 'Strážiť dostupnosť',
        yourEmail: 'Váš e-mail',
        nwlDisagree: 'Neprajem si byť informovaný o exkluzívnych ponukách a často nakupovaných produktoch',
        iAgree: 'Chcem sa registrovať a súhlasím s',
        termsAndCondition: 'obchodnými podmienkami',
        termsAndConditionUrl: '/obchodne-podmienky',
        andWith: 'a so',
        processingData: 'spracovaním osobných údajov',
        processingDataUrl: '/zasady-o-ochrane-osobnych-udajov',
        registrationAgreement: 'Prosíme o súhlas so spracovaním osobných údajov',
        watchdogProductUpserted:
            'Ďakujeme za váš záujem o produkt. Hneď ako ho naskladníme, odošleme vám upozornenie na zadanú adresu. Pozor! Počet produktov je obmedzený.',
        late: 'Mrzí nás to, niekto bol rýchlejší.<br> Chcete produkt strážiť ďalej?',
        yes: 'Áno',
        no: 'Nie',
    },
    publicHolidays: [
        '2024-01-01',
        '2024-01-06',
        '2024-03-29',
        '2024-04-01',
        '2024-05-01',
        '2024-05-08',
        '2024-07-05',
        '2024-08-29',
        '2024-09-01',
        '2024-09-15',
        '2024-11-01',
        '2024-11-17',
        '2024-12-24',
        '2024-12-25',
        '2024-12-26',
        '2025-01-01',
        '2025-01-06',
        '2025-04-18',
        '2025-04-21',
        '2025-05-01',
        '2025-05-08',
        '2025-07-05',
        '2025-08-29',
        '2025-09-01',
        '2025-09-15',
        '2025-11-01',
        '2025-11-17',
        '2025-12-24',
        '2025-12-25',
        '2025-12-26',
        '2026-01-01',
        '2026-01-06',
        '2026-04-03',
        '2026-04-06',
        '2026-05-01',
        '2026-05-08',
        '2026-07-05',
        '2026-08-29',
        '2026-09-01',
        '2026-09-15',
        '2026-11-01',
        '2026-11-17',
        '2026-12-24',
        '2026-12-25',
        '2026-12-26',
        '2027-01-01',
        '2027-01-06',
        '2027-03-26',
        '2027-03-29',
        '2027-05-01',
        '2027-05-08',
        '2027-07-05',
        '2027-08-29',
        '2027-09-01',
        '2027-09-15',
        '2027-11-01',
        '2027-11-17',
        '2027-12-24',
        '2027-12-25',
        '2027-12-26',
        '2028-01-01',
        '2028-01-06',
        '2028-04-14',
        '2028-04-17',
        '2028-05-01',
        '2028-05-08',
        '2028-07-05',
        '2028-08-29',
        '2028-09-01',
        '2028-09-15',
        '2028-11-01',
        '2028-11-17',
        '2028-12-24',
        '2028-12-25',
        '2028-12-26',
        '2029-01-01',
        '2029-01-06',
        '2029-03-30',
        '2029-04-02',
        '2029-05-01',
        '2029-05-08',
        '2029-07-05',
        '2029-08-29',
        '2029-09-01',
        '2029-09-15',
        '2029-11-01',
        '2029-11-17',
        '2029-12-24',
        '2029-12-25',
        '2029-12-26',
        '2030-01-01',
        '2030-01-06',
        '2030-04-19',
        '2030-04-22',
        '2030-05-01',
        '2030-05-08',
        '2030-07-05',
        '2030-08-29',
        '2030-09-01',
        '2030-09-15',
        '2030-11-01',
        '2030-11-17',
        '2030-12-24',
        '2030-12-25',
        '2030-12-26',
    ],
    aboutUsStructuredData: {
        staticPageName: 'O nás',
        description: 'Pilulka.cz je e-shop s více než 100 lékárnami v ČR, nabízející širokou nabídku produktů pro zdraví a prevenci.',
        name: 'O nás - Pilulka.cz',
        alternateName: ['Pilulka Lékárny', 'Pilulka'],
        award: ['Ecommerce Awards', 'Křišťálová Lupa 2015', 'Ecommerce Awards 2014', 'Deloitte Technology Fast50'],
        founders: ['Petr Kasa', 'Martin Kasa'],
        sameAs: [
            'https://cs.wikipedia.org/wiki/Pilulka_L%C3%A9k%C3%A1rny',
            'https://www.wikidata.org/wiki/Q41960196',
            'https://rejstrik-firem.kurzy.cz/03615278/pilulka-lekarny-as/',
            'https://www.facebook.com/Pilulka.cz/',
            'https://twitter.com/Pilulkacz',
            'https://www.instagram.com/pilulkacz/',
            'https://www.youtube.com/channel/UCHZjKRINTuPndlUTycblCzA',
            'https://www.tiktok.com/@pilulka_cz',
        ],
        taxID: 'CZ03615278',
        hasMap: ['https://maps.app.goo.gl/Wv5YkyVqaeDP6crD7', 'https://mapy.cz/s/kesafufatu'],
        contactPoint: {
            telephone: '+420222703000',
            contactType: 'Customer Service',
            availableLanguage: 'Czech',
            email: "dotazy{'@'}pilulka.cz",
        },
        address: {
            streetAddress: 'Českomoravská 2408/1a',
            addressLocality: 'Praha 9 - Libeň',
            postalCode: '19000',
            addressCountry: 'CZ',
            addressRegion: 'Hlavní Město Praha',
        },
    },
    topicBanner: {
        cta: 'Preskúmať',
    },
    orderDetail: {
        loadMore: 'Načítať ďalšie',
        title: 'Objednávky',
        pilulkaBoxMoreInfo: 'Viac informácií o vyzdvihnutí z Pilulka Boxu',
        pilulkaBoxPickup: 'Vyzdvihnúť objednávku',
        sharePickupLink: 'Zdieľať odkaz pre vyzdvihnutie',
        orderPayAndConfirm: 'Zvoliť platbu a zaplatiť',
        resumePayment: 'Dokončiť platbu',
        orderProlongContext: 'Predĺžiť o',
        orderProlongConfirm: 'Naozaj si prajete objednávku predĺžiť?',
        orderCancelConfirm: 'Naozaj si prajete objednávku stornovať?',
        orderCancelButton: 'Stornovať',
        repeatOrder: 'Opakovať objednávku',
        yourPackagesNumber: 'Vaše balíčky č.',
        packagesOnTheWay: 'už sú na ceste k vám.',
        yourPackageNumber: 'Váš balíček č.',
        packageOnTheWay: 'už je na ceste k vám.',
        tracePackageNumber: 'Sledovať balíček č.',
        packageDelivered: 'už bol doručený.',
        packagesDelivered: 'už boli doručené.',
        deliveryDateEstimate: '*Termín doručenia je odhadovaný, urobíme všetko pre jeho dodržanie, ale nemôžeme ho garantovať.',
        paymentTransferInfo:
            'Platba prevodom prebehne do dvoch pracovných dní. Prosím, vykonajte platbu teraz, aby sme mohli objednávku čo najskôr odoslať.',
        paymentAccountInfo: 'Platbu prosím uhraďte na nasledujúci účet',
        paymentVariableSymbol: 'a nezabudnite správne uviesť variabilný symbol',
        bankName: 'Názov banky',
        bankAccount: 'Bankový účet',
        variableSymbol: 'Variabilný symbol',
        paymentAmount: 'Suma',
        readyAtDepot: 'Pripravené na sklade',
        onTheWayToDepot: 'Na ceste na sklad',
        totalPriceWithTax: 'Celková cena s DPH',
        contactInfo: 'Kontaktné údaje',
        deliveryAddress: 'Doručovacia adresa',
        xDays: '{n} deň|{n} dni|{n} dní',
        and: 'a',
        yourOrder: 'Váš nákup',
        downloadInvoice: 'Faktúra',
        firstPartOfOrder: 'Prvá časť objednávky',
        secondPartOfOrder: 'Druhá časť objednávky',
        orderState: 'Stav objednávky',
        payNoMoreForDeliveryWithPilulkaPremium: 'DOPRAVA ZADARMO a zdravie pod palcom',
        pilulkaPremiumBrief:
            'Získajte doručenie do Pilulka Boxu a na Pilulka Lekárne <b>ZADARMO</b>.<br>Doručenie domov môžete využiť až 12× <b>ZADARMO</b>.',
        pilulkaPremiumMoreInfo: 'Zistiť viac',
        continue: 'Pokračovať',
        firstSelectPaymentMethod: 'Najskôr vyberte platobnú metódu',
        free: 'Zadarmo',
        selectPaymentMethodForOrder: 'Vyberte typ platby pre objednávku',
    },
    favoriteProducts: {
        title: 'Obľúbené produkty',
        noResults: 'V obľúbených zatiaľ nič nemáte',
    },
    userProfile: {
        title: 'Osobné údaje',
        contactInfo: 'Kontaktné údaje',
        edit: 'Upraviť',
        nameAndLastName: 'Meno a priezvisko',
        email: 'E-mail',
        phone: 'Telefónne číslo',
        address: 'Adresa',
        password: 'Heslo',
        currentPassword: 'Súčasné heslo',
        newPassword: 'Nové heslo',
        newPasswordVerify: 'Potvrdenie hesla',
        changePassword: 'Zmeniť heslo',
        passwordChanged: 'Heslo zmenené',
        joinProfile: 'Prepojiť účet',
        joinFacebookAccount: 'Prepojiť s Facebook účtom',
        joinGoogleAccount: 'Prepojiť s Google účtom',
        creditCards: 'Zapamätané karty',
        deleteRememberedCard: 'Zmazať kartu',
        whatReportsDoYouWishToReceive: 'Aké správy si prajete dostávať?',
        subscriptionText:
            'Získajte prístup ku všetkým zľavám ako prví a nenechajte si ujsť žiadnu špeciálnu ponuku na Pilulka.sk. Vždy sa môžete veľmi jednoducho odhlásiť.',
        fromHasBeenSubmitted: 'Nastavenie upravené',
        youAreSubscribedToPilulkaNewsletter: 'Odobierate exkluzívne ponuky z Pilulky',
        youAreNotSubscribedToPilulkaNewsletter: 'Neodobierate exkluzívne ponuky z Pilulky',
        iDoNotWantToBeInformed: 'Neprajem si byť informovaný/á o exkluzívnych ponukách a často nakupovaných produktoch',
        iWantToBeInformed: 'Prajem si byť informovaný/á o exkluzívnych ponukách a často nakupovaných produktoch',
        saveInfo: 'Uložiť údaje',
        addNewUserCreditCard: 'Pridať platobnú kartu',
        setAsPrimary: 'Nastaviť ako primárnu',
        primaryUserCreditCardDescription: 'Primárna karta bude použitá na strhávanie predplatného Pilulka Premium',
        pay0AndRememberCard: 'Zaplatiť 0 € a zapamätať kartu',
        cardRememberingFailed: 'Bohužiaľ sa nepodarilo kartu uložiť',
        primaryCardLabel: 'Primárna',
    },
    userFeedback: {
        title: 'Moje hodnotenia a komentáre',
        rate: 'Ohodnotiť',
        noResults: 'Zatiaľ nemáte žiadne hodnotenia',
    },
    editProfile: {
        personalInfo: 'Osobné údaje',
        invoiceInfo: 'Fakturačné údaje',
        deliveryInfo: 'Dodacia adresa',
        saveChanges: 'Uložiť zmeny',
        formSubmitted: 'Uložené',
    },
    registration: {
        title: 'Zaregistrujte sa',
        description:
            'Staňte sa zdarma členmi <a href="/pilulka-premium" class="text-primary">Pilulka Premium</a> a využívajte neobmedzenú dopravu zdarma do Boxov a Lekární, alebo si nákup nechajte poslať až k dverám. Máte už účet? <a href="/prihlasit-se" class="text-primary">Prihláste sa</a>',
        password: 'Heslo',
        passwordVerify: 'Heslo znovu',
        buttonTitle: 'Registrovať sa',
        agreementText:
            'Súhlasím s <a href="/obchodni-podminky" class="text-primary tdu" target="_blank">Obchodnými podmienkami</a> a so <a href="/zasady-o-ochrane-osobnych-udajov" class="text-primary tdu" target="_blank">spracovaním osobných údajov</a>',
        loginWithGoogleAccount: 'Prihlásiť sa cez Google',
        passwordIsWeak: 'Vaše heslo musí mať minimálne 8 znakov obsahujúcich číslicu aj písmeno',
        passwordsMustBeEqual: 'Heslá sa musia zhodovať',
        conditionsRequired: 'Prosíme o súhlas so spracovaním osobných údajov',
        marketingCheckboxLabel: 'Chcem byť informovaný/á o exkluzívnych ponukách a často nakupovaných produktoch',
    },
    loginPage: {
        title: 'Prihlásenie',
        description:
            'Ešte sa nepoznáme? <a href="/registrace" class="text-primary">Vytvorte si u nás účet</a>. Ak ste zabudli heslo, <a href="/zapomenute-heslo" class="text-primary">pošleme vám nové</a>',
        password: 'Heslo',
        emailRequired: 'Zadajte e-mail',
        passwordRequired: 'Zadajte heslo',
        buttonTitle: 'Prihlásiť sa',
        loginWithGoogleAccount: 'Prihlásiť sa cez Google',
        verifyTitle: 'Zadajte overovací kód',
        verifyDescription: 'Na dokončenie prihlásenia zadajte overovací kód, ktorý sme vám poslali na e-mail.',
        verificationCode: 'Overovací kód',
    },
    forgottenPasswordPage: {
        title: 'Zabudnuté heslo',
        description: 'Zadajte, prosím, váš e-mail a my vám zašleme odkaz na obnovenie hesla.',
        emailRequired: 'Zadajte e-mail',
        buttonTitle: 'Zaslať zabudnuté heslo',
        passwordSuccessfullyReset: 'Odkaz na obnovenie hesla sme vám poslali na e-mail.',
    },
    pickupPlaceList: {
        title: 'Odberné miesta Pilulka.sk',
        text: 'Vyhľadajte si Pilulka Lekárne, Výdajné Boxy alebo ďalšie odberné miesta vo vašom okolí.',
        showDetails: 'Zobraziť podrobnosti',
        todayOpened: 'Dnes otvorené',
        tomorrowOpened: 'Zajtra otvorené',
        tabs: [
            {
                type: 'all',
                title: 'Všetko',
                isBox: null,
            },
            // {
            //     type: 'DEL_PILULKA_BOX',
            //     title: 'Pilulka Box',
            //     isBox: null,
            // },
            {
                type: 'DEL_PERSONAL',
                title: 'Pilulka Lekáreň',
                isBox: null,
            },
            {
                type: 'DEL_ZASILKOVNA',
                title: 'Packeta výdajné místo',
                isBox: false,
            },
            {
                type: 'DEL_ZASILKOVNA',
                title: 'Packeta Z-box',
                isBox: true,
            },
            // {
            //     type: 'DEL_SKPOST__NP',
            //     title: 'Slovenská pošta',
            //     isBox: null,
            // },
        ],
    },
    adyen: {
        securityMessage:
            'Adyen je bezpečná a spoľahlivá platobná brána.<br />Spoločnosť Pilulka nemá údaje o karte uložené, ani k nim nemá prístup.',
        footerInfoText:
            'Platba prebieha pomocou certifikovanej platobnej brány Adyen N.V. (34259528) Simon Carmiggeltstraat 6-50, 1011 DJ in Amsterdam, the Netherlands.',
    },
    brandsList: {
        title: 'Prehľad značiek',
    },
    customerCare: {
        phoneOpeningHours: {
            monday: '8:00 - 18:00',
            tuesday: '8:00 - 18:00',
            wednesday: '8:00 - 18:00',
            thursday: '8:00 - 18:00',
            friday: '8:00 - 18:00',
            saturday: '',
            sunday: '',
        },
        chatOpeningHours: {
            monday: '8:00 - 21:00',
            tuesday: '8:00 - 21:00',
            wednesday: '8:00 - 21:00',
            thursday: '8:00 - 21:00',
            friday: '8:00 - 21:00',
            saturday: '',
            sunday: '',
        },
    },
    timezone: 'Europe/Prague',
}
